import React, { useState, useEffect, useMemo } from "react";
import { motion, AnimatePresence } from "framer-motion";
import StoreSidebar from "../components/StoreSidebar";
import { getAuth, onAuthStateChanged } from "firebase/auth";

import { db } from "../firebase/firebase";
import { 
  collection, 
  onSnapshot, 
  doc, 
  runTransaction,
  updateDoc,
  deleteDoc,
  query,
  where,
  getDocs,
  setDoc,
  addDoc
} from "firebase/firestore";
import {
  User, ShoppingBag, Search, Plus, Trash2, 
  CreditCard, AlertCircle, MapPin, RefreshCw, History, ShieldCheck,
  CheckCircle2, Calendar, Edit3, Printer, Eye, QrCode, ShoppingCart, FileText, X, UserPlus, Stethoscope, Percent, ClipboardList, Receipt, MessageCircle, MessageSquare
} from "lucide-react";

const INDIAN_STATES = [
  "Andaman and Nicobar Islands", "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", 
  "Chandigarh", "Chhattisgarh", "Dadra and Nagar Haveli and Daman and Diu", "Delhi", "Goa", 
  "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka", "Kerala", "Lakshadweep", 
  "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya", "Mizoram", "Nagaland", "Odisha", 
  "Puducherry", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana", " त्रिपुरा (Tripura)", 
  "Uttar Pradesh", "Uttarakhand", "West Bengal"
];

export default function AdvancedBillingMatrix() {
  const [activeTab, setActiveTab] = useState("newOrder"); 
  const [activeBranchId, setActiveBranchId] = useState(""); 
  const [storesList, setStoresList] = useState([]);
  
  const [storeName, setStoreName] = useState("");
  
  const [activeStoreAdress, setActiveStoreAdress] = useState("");
  const [activeStoreNumber, setActiveStoreNumber] = useState("");
  const [activeStoreMobNumber, setActiveStoreMobNumber] = useState("");

  
  // Data State
  const [products, setProducts] = useState([]);
  const [salesHistoryData, setSalesHistoryData] = useState([]);
  const [storeEmployees, setStoreEmployees] = useState([]); 
  const [billingCart, setBillingCart] = useState([]);
  const [skuSearchQuery, setSkuSearchQuery] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);
  const [systemError, setSystemError] = useState(null);
  const [lastInvoiceNo, setLastInvoiceNo] = useState("");

  // Product Category Quick Add State
  const [showProductTypePopup, setShowProductTypePopup] = useState(false);
  const [selectedProductType, setSelectedProductType] = useState("");
  const [productTypeSearchQuery, setProductTypeSearchQuery] = useState("");
  const [quickAddForm, setQuickAddForm] = useState(null);

  // Filter States
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [filterSearch, setFilterSearch] = useState("");
  const [filterStatus, setFilterStatus] = useState("");

  // Form State
  const [editOrderId, setEditOrderId] = useState(null); 
  const [salesDate, setSalesDate] = useState(""); 
  const [deliveryDate, setDeliveryDate] = useState("");
  const [orderReference, setOrderReference] = useState("");
  
  const [customerName, setCustomerName] = useState("");
  const [customerPhone, setCustomerPhone] = useState("");
  const [customerPhone2, setCustomerPhone2] = useState("");
  const [customerDob, setCustomerDob] = useState("");
  const [customerAnniversary, setCustomerAnniversary] = useState("");
  const [customerCompany, setCustomerCompany] = useState("");
  const [customerAddress, setCustomerAddress] = useState("");
  const [customerLocality, setCustomerLocality] = useState("");
  const [customerState, setCustomerState] = useState("");
  const [customerPincode, setCustomerPincode] = useState("");
  const [customerNotes, setCustomerNotes] = useState("");

  const [salesperson, setSalesperson] = useState("");
  const [overallDiscountType, setOverallDiscountType] = useState("amount"); 
  const [overallDiscountValue, setOverallDiscountValue] = useState("");
  const [advancePaid, setAdvancePaid] = useState("");
  const [taxPercentage, setTaxPercentage] = useState("12");
  const [taxRule, setTaxRule] = useState("include");
  const [paymentMode, setPaymentMode] = useState("CASH");
  const [posPaymentDetails, setPosPaymentDetails] = useState("");
  const [roundOff, setRoundOff] = useState("");

  // --- PRESCRIPTION MATRIX STATES ---
  const [savedPrescriptions, setSavedPrescriptions] = useState([]);
  const [selectedPrescriptionId, setSelectedPrescriptionId] = useState("");
  
  const [patientName, setPatientName] = useState("");
  const [patientMobile, setPatientMobile] = useState("");
  const [patientEmail, setPatientEmail] = useState("");
  const [patientDob, setPatientDob] = useState("");
  const [patientAge, setPatientAge] = useState("");
  const [patientGender, setPatientGender] = useState("Male");

  const [doctorName, setDoctorName] = useState("");
  const [doctorMobile, setDoctorMobile] = useState("");
  const [doctorAddress, setDoctorAddress] = useState("");

  const [sphRight, setSphRight] = useState(""); const [cylRight, setCylRight] = useState(""); const [axisRight, setAxisRight] = useState("");
  const [sphLeft, setSphLeft] = useState(""); const [cylLeft, setCylLeft] = useState(""); const [axisLeft, setAxisLeft] = useState("");
  const [nvSphRight, setNvSphRight] = useState(""); const [nvCylRight, setNvCylRight] = useState(""); const [nvAxisRight, setNvAxisRight] = useState("");
  const [nvSphLeft, setNvSphLeft] = useState(""); const [nvCylLeft, setNvCylLeft] = useState(""); const [nvAxisLeft, setNvAxisLeft] = useState("");
  const [pdRight, setPdRight] = useState(""); const [vaRight, setVaRight] = useState(""); const [addRight, setAddRight] = useState("");
  const [pdLeft, setPdLeft] = useState(""); const [vaLeft, setVaLeft] = useState(""); const [addLeft, setAddLeft] = useState("");

  const [clSphRight, setClSphRight] = useState(""); const [clCylRight, setClCylRight] = useState(""); const [clAxisRight, setClAxisRight] = useState("");
  const [clSphLeft, setClSphLeft] = useState(""); const [clCylLeft, setClCylLeft] = useState(""); const [clAxisLeft, setClAxisLeft] = useState("");
  const [clNvSphRight, setClNvSphRight] = useState(""); const [clNvCylRight, setClNvCylRight] = useState(""); const [clNvAxisRight, setClNvAxisRight] = useState("");
  const [clNvSphLeft, setClNvSphLeft] = useState(""); const [clNvCylLeft, setClNvCylLeft] = useState(""); const [clNvAxisLeft, setClNvAxisLeft] = useState("");
  const [clAddRight, setClAddRight] = useState(""); const [clAddLeft, setClAddLeft] = useState("");

  const [trnSphRight, setTrnSphRight] = useState(""); const [trnCylRight, setTrnCylRight] = useState(""); const [trnAxisRight, setTrnAxisRight] = useState("");
  const [trnSphLeft, setTrnSphLeft] = useState(""); const [trnCylLeft, setTrnCylLeft] = useState(""); const [trnAxisLeft, setTrnAxisLeft] = useState("");
  const [trnNvSphRight, setTrnNvSphRight] = useState(""); const [trnNvCylRight, setTrnNvCylRight] = useState(""); const [trnNvAxisRight, setTrnNvAxisRight] = useState("");
  const [trnNvSphLeft, setTrnNvSphLeft] = useState(""); const [trnNvCylLeft, setTrnNvCylLeft] = useState(""); const [trnNvAxisLeft, setTrnNvAxisLeft] = useState("");
  const [trnAddRight, setTrnAddRight] = useState(""); const [trnAddLeft, setTrnAddLeft] = useState("");

  const [lensTypes, setLensTypes] = useState([]);
  const [eyeTestRecord, setEyeTestRecord] = useState("Yes");
  const [prescriptionNotes, setPrescriptionNotes] = useState("");
  
  // Modal States
  const [showPrescriptionModal, setShowPrescriptionModal] = useState(false);
  const [prescriptionTab, setPrescriptionTab] = useState("eyewear");
  const [completingOrder, setCompletingOrder] = useState(null);
  const [completionPaymentMode, setCompletionPaymentMode] = useState("CASH");
  const [completionPaymentDetails, setCompletionPaymentDetails] = useState("");
  const [completionRoundOff, setCompletionRoundOff] = useState("");

  // Custom Product State
  const [customItem, setCustomItem] = useState({ productCode: "", productName: "", customPrice: "" });
  
  // Unified Contact Modal State
  const [showContactModal, setShowContactModal] = useState(false);
  const [contactOrder, setContactOrder] = useState(null);
  const [contactMethod, setContactMethod] = useState("whatsapp");

  const resolvedBranchName = useMemo(() => {
    const matched = storesList.find(s => s.id === activeBranchId);
    return matched ? (matched.storeName || matched.id) : "Main Branch";
  }, [activeBranchId, storesList]);

  useEffect(() => {
    const auth = getAuth();
    let unsubStore = null;

    const unsubscribeAuth = onAuthStateChanged(auth, (user) => {
      if (user) {
        const storeQuery = query(collection(db, "stores"), where("linkedAuthUid", "==", user.uid));
        
        unsubStore = onSnapshot(storeQuery, (snapshot) => {
          if (!snapshot.empty) {
            const storeDoc = snapshot.docs[0];
            setActiveBranchId(storeDoc.id); 
            setStoreName(storeDoc.data().storeId || storeDoc.data().storeId);
            setActiveStoreAdress(storeDoc.data().address || "CHANDRAKANTI COMPLEX OPP KHAJPURA, PATNA - 800014, Bihar, India" );
            setActiveStoreNumber(storeDoc.data().landline || storeDoc.data().landline || "06123590450");
            setActiveStoreMobNumber(storeDoc.data().phone || storeDoc.data().phone  || "06123590450");

          } else {
            console.warn("No authorized store found for this user.");
          }
        });
      }
    });

    return () => {
      unsubscribeAuth();
      if (unsubStore) unsubStore();
    };
  }, []);
  
  // --- FETCHING LOGIC ---
  useEffect(() => {
    const unsubStores = onSnapshot(collection(db, "stores"), (snapshot) => {
      const pulledStores = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
      setStoresList(pulledStores);
    });
    return () => unsubStores();
  }, []);

  useEffect(() => {
    if (!activeBranchId) return;
    const unsubInv = onSnapshot(collection(db, "stores", activeBranchId, "inventory"), (snap) => setProducts(snap.docs.map(d => ({ id: d.id, ...d.data() }))));
    const unsubSales = onSnapshot(collection(db, "stores", activeBranchId, "sales"), (snap) => setSalesHistoryData(snap.docs.map(d => ({ id: d.id, ...d.data() })).sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))));
    const unsubEmp = onSnapshot(collection(db, "stores", activeBranchId, "employees"), (snap) => setStoreEmployees(snap.docs.map(d => ({ id: d.id, ...d.data() }))));
    
    const unsubRx = onSnapshot(collection(db, "stores", activeBranchId, "prescriptions"), (snap) => {
      setSavedPrescriptions(snap.docs.map(d => ({ id: d.id, ...d.data() })).sort((a, b) => new Date(b.timestamp || 0) - new Date(a.timestamp || 0)));
    });

    return () => { unsubInv(); unsubSales(); unsubEmp(); unsubRx(); };
  }, [activeBranchId]);

  useEffect(() => {
    if (patientDob) {
      const dob = new Date(patientDob);
      const diff = Date.now() - dob.getTime();
      const ageDate = new Date(diff); 
      setPatientAge(Math.abs(ageDate.getUTCFullYear() - 1970).toString());
    }
  }, [patientDob]);

  const handlePhoneBlurCustomer = async () => {
    if (!customerPhone || customerPhone.length < 10 || !activeBranchId) return;
    try {
      const custQ = query(collection(db, "stores", activeBranchId, "customers"), where("phone", "==", customerPhone));
      const custSnap = await getDocs(custQ);
      if (!custSnap.empty) {
        const cData = custSnap.docs[0].data();
        if(cData.name) setCustomerName(cData.name);
        if(cData.phone2) setCustomerPhone2(cData.phone2);
        if(cData.dob) setCustomerDob(cData.dob);
        if(cData.anniversary) setCustomerAnniversary(cData.anniversary);
        if(cData.company) setCustomerCompany(cData.company);
        if(cData.address) setCustomerAddress(cData.address);
        if(cData.locality) setCustomerLocality(cData.locality);
        if(cData.state) setCustomerState(cData.state);
        if(cData.pincode) setCustomerPincode(cData.pincode);
        if(cData.notes) setCustomerNotes(cData.notes);
      }
    } catch (err) {
      console.error("Failed to auto-fetch customer data:", err);
    }
  };

  const clearPrescriptionForm = () => {
    setSelectedPrescriptionId(""); setPatientName(""); setPatientMobile(""); setPatientEmail(""); setPatientDob(""); setPatientAge(""); setPatientGender("Male");
    setDoctorName(""); setDoctorMobile(""); setDoctorAddress("");
    setSphLeft(""); setSphRight(""); setCylLeft(""); setCylRight(""); setAxisLeft(""); setAxisRight(""); setPdRight(""); setPdLeft(""); setVaRight(""); setVaLeft(""); setAddRight(""); setAddLeft("");
    setNvSphLeft(""); setNvSphRight(""); setNvCylLeft(""); setNvCylRight(""); setNvAxisLeft(""); setNvAxisRight("");
    setClSphRight(""); setClSphLeft(""); setClCylRight(""); setClCylLeft(""); setClAxisRight(""); setClAxisLeft(""); setClAddRight(""); setClAddLeft("");
    setClNvSphRight(""); setClNvSphLeft(""); setClNvCylRight(""); setClNvCylLeft(""); setClNvAxisRight(""); setClNvAxisLeft("");
    setTrnSphRight(""); setTrnSphLeft(""); setTrnCylRight(""); setTrnCylLeft(""); setTrnAxisRight(""); setTrnAxisLeft(""); setTrnAddRight(""); setTrnAddLeft("");
    setTrnNvSphRight(""); setTrnSphLeft(""); setTrnNvCylRight(""); setTrnNvCylLeft(""); setTrnNvAxisRight(""); setTrnNvAxisLeft("");
    setLensTypes([]); setEyeTestRecord("Yes"); setPrescriptionNotes("");
  };

  const resetForm = () => {
    setBillingCart([]); 
    setCustomerName(""); setCustomerPhone(""); setCustomerPhone2(""); setCustomerAddress(""); setSalesperson(""); setCustomerCompany(""); setCustomerLocality(""); setCustomerState(""); setCustomerPincode(""); setCustomerNotes(""); setCustomerDob(""); setCustomerAnniversary("");
    clearPrescriptionForm();
    setAdvancePaid(""); setDeliveryDate(""); setOrderReference(""); setRoundOff(""); setOverallDiscountType("amount"); setOverallDiscountValue(""); setPosPaymentDetails(""); setPaymentMode("CASH");
    setEditOrderId(null);
  };

  const isLensProduct = (product) => {
    const pName = product.productName?.toLowerCase() || "";
    const pCode = product.productCode?.toLowerCase() || "";
    return pName.includes("lens") || pCode.includes("lens") || product.productType === "Glass" || product.productType === "Lens" || product.productType === "Contact Lens";
  };

  const handleSelectPrescription = (rxId) => {
    setSelectedPrescriptionId(rxId);
    if (!rxId) return;
    const rxData = savedPrescriptions.find(p => p.id === rxId);
    if (!rxData) return;

    if(rxData.patient) {
      setPatientName(rxData.patient.name || ""); setPatientMobile(rxData.patient.mobile || "");
      setPatientEmail(rxData.patient.email || ""); setPatientDob(rxData.patient.dob || "");
      setPatientAge(rxData.patient.age || ""); setPatientGender(rxData.patient.gender || "Male");
    }
    if(rxData.doctor) {
      setDoctorName(rxData.doctor.name || ""); setDoctorMobile(rxData.doctor.mobile || "");
      setDoctorAddress(rxData.doctor.address || "");
    }
    if(rxData.sphLeft) setSphLeft(rxData.sphLeft); if(rxData.sphRight) setSphRight(rxData.sphRight);
    if(rxData.cylLeft) setCylLeft(rxData.cylLeft); if(rxData.cylRight) setCylRight(rxData.cylRight);
    if(rxData.axisLeft) setAxisLeft(rxData.axisLeft); if(rxData.axisRight) setAxisRight(rxData.axisRight);
    if(rxData.nvSphLeft) setNvSphLeft(rxData.nvSphLeft); if(rxData.nvSphRight) setNvSphRight(rxData.nvSphRight);
    if(rxData.nvCylLeft) setNvCylLeft(rxData.nvCylLeft); if(rxData.nvCylRight) setNvCylRight(rxData.nvCylRight);
    if(rxData.nvAxisLeft) setNvAxisLeft(rxData.nvAxisLeft); if(rxData.nvAxisRight) setNvAxisRight(rxData.nvAxisRight);
    if(rxData.pdLeft) setPdLeft(rxData.pdLeft); if(rxData.pdRight) setPdRight(rxData.pdRight);
    if(rxData.vaLeft) setVaLeft(rxData.vaLeft); if(rxData.vaRight) setVaRight(rxData.vaRight);
    if(rxData.addLeft) setAddLeft(rxData.addLeft); if(rxData.addRight) setAddRight(rxData.addRight);
    
    if(rxData.clSphLeft) setClSphLeft(rxData.clSphLeft); if(rxData.clSphRight) setClSphRight(rxData.clSphRight);
    if(rxData.clCylLeft) setClCylLeft(rxData.clCylLeft); if(rxData.clCylRight) setClCylRight(rxData.clCylRight);
    if(rxData.clAxisLeft) setClAxisLeft(rxData.clAxisLeft); if(rxData.clAxisRight) setClAxisRight(rxData.clAxisRight);
    if(rxData.clNvSphLeft) setClNvSphLeft(rxData.clNvSphLeft); if(rxData.clNvSphRight) setClNvSphRight(rxData.clNvSphRight);
    if(rxData.clNvCylLeft) setClNvCylLeft(rxData.clNvCylLeft); if(rxData.clNvCylRight) setClNvCylRight(rxData.clNvCylRight);
    if(rxData.clNvAxisLeft) setClNvAxisLeft(rxData.clNvAxisLeft); if(rxData.clNvAxisRight) setClNvAxisRight(rxData.clNvAxisRight);
    if(rxData.clAddLeft) setClAddLeft(rxData.clAddLeft); if(rxData.clAddRight) setClAddRight(rxData.clAddRight);

    if(rxData.trnSphLeft) setTrnSphLeft(rxData.trnSphLeft); if(rxData.trnSphRight) setTrnSphRight(rxData.trnSphRight);
    if(rxData.trnCylLeft) setTrnCylLeft(rxData.trnCylLeft); if(rxData.trnCylRight) setTrnCylRight(rxData.trnCylRight);
    if(rxData.trnAxisLeft) setTrnAxisLeft(rxData.trnAxisLeft); if(rxData.trnAxisRight) setTrnAxisRight(rxData.trnAxisRight);
    if(rxData.trnNvSphLeft) setTrnNvSphLeft(rxData.trnNvSphLeft); if(rxData.trnNvSphRight) setTrnNvSphRight(rxData.trnNvSphRight);
    if(rxData.trnNvCylLeft) setTrnNvCylLeft(rxData.trnNvCylLeft); if(rxData.trnNvCylRight) setTrnNvCylRight(rxData.trnNvCylRight);
    if(rxData.trnNvAxisLeft) setTrnNvAxisLeft(rxData.trnNvAxisLeft); if(rxData.trnNvAxisRight) setTrnNvAxisRight(rxData.trnNvAxisRight);
    if(rxData.trnAddLeft) setTrnAddLeft(rxData.trnAddLeft); if(rxData.trnAddRight) setTrnAddRight(rxData.trnAddRight);

    if(rxData.lensTypes) setLensTypes(rxData.lensTypes);
    if(rxData.eyeTestRecord) setEyeTestRecord(rxData.eyeTestRecord);
    if(rxData.prescriptionNotes) setPrescriptionNotes(rxData.prescriptionNotes);
  };

  const scannedMatches = useMemo(() => {
    if (!skuSearchQuery.trim()) return [];
    return products.filter(p => p.productName?.toLowerCase().includes(skuSearchQuery.toLowerCase()) || p.productCode?.toLowerCase().includes(skuSearchQuery.toLowerCase()));
  }, [skuSearchQuery, products]);

  const completedSalesLedger = useMemo(() => {
    return salesHistoryData.filter(s => {
      if (!s.timestamp) return true;
      const orderDate = s.timestamp.split("T")[0];
      if (startDate && orderDate < startDate) return false;
      if (endDate && orderDate > endDate) return false;
      
      const bal = s.financials?.balanceDue || 0;
      if (filterStatus === "Pending" && bal <= 0) return false;
      if (filterStatus === "Completed" && bal > 0) return false;

      if (filterSearch) {
        const term = filterSearch.toLowerCase();
        const matchInv = s.invoiceNo?.toLowerCase().includes(term);
        const matchName = s.customer?.name?.toLowerCase().includes(term);
        const matchPhone = s.customer?.phone?.includes(term);
        if (!matchInv && !matchName && !matchPhone) return false;
      }
      return true;
    });
  }, [salesHistoryData, startDate, endDate, filterStatus, filterSearch]);

  const loadOrderForEditing = (order) => {
    setEditOrderId(order.id);
    
    const mappedCart = (order.items || []).map((i, idx) => ({
      ...i,
      id: i.productCode || `imported_${idx}`,
      productCode: i.productCode || "",
      productName: i.productName || "",
      retailPrice: Number(i.retailPrice) || Number(i.mrp) || 0,
      mrp: Number(i.mrp) || Number(i.retailPrice) || 0,
      cartQuantity: Number(i.quantity) || 1,
      customDiscount: Number(i.discount) || 0,
      discountType: i.discountType || "amount",
      discountValue: Number(i.discountValue) || Number(i.discount) || 0,
      hsnCode: i.hsnCode || "",
      gstPercent: Number(i.gstPercent) || 0,
      isCustomItem: !products.some(p => p.productCode === i.productCode)
    }));
    setBillingCart(mappedCart);

    setCustomerName(order.customer?.name || "");
    setCustomerPhone(order.customer?.phone || "");
    setCustomerPhone2(order.customer?.phone2 || "");
    setCustomerDob(order.customer?.dob || "");
    setCustomerAnniversary(order.customer?.anniversary || "");
    setCustomerCompany(order.customer?.company || "");
    setCustomerAddress(order.customer?.address || "");
    setCustomerLocality(order.customer?.locality || "");
    setCustomerState(order.customer?.state || "");
    setCustomerPincode(order.customer?.pincode || "");
    setCustomerNotes(order.customer?.notes || "");

    setSalesperson(order.salesperson || "");
    setSalesDate(order.checkout?.placementDate || "");
    setDeliveryDate(order.checkout?.deliveryDate || "");
    setOrderReference(order.invoiceNo || "");
    
    setTaxRule(order.checkout?.taxRule || "include");
    setTaxPercentage(order.checkout?.taxPercentage || "12");
    setOverallDiscountType(order.checkout?.overallDiscountType || "amount");
    setOverallDiscountValue(order.checkout?.overallDiscountValue || "");
    setRoundOff(order.checkout?.roundOff || "");
    setAdvancePaid(order.checkout?.advancePaid || "");

    const firstPayment = order.checkout?.paymentHistory?.[0] || {};
    setPaymentMode(firstPayment.mode || order.checkout?.paymentMode || "CASH");
    setPosPaymentDetails(firstPayment.details || "");

    if (order.prescription) {
      const rxData = order.prescription;
      setPatientName(rxData.patient?.name || "");
      setPatientMobile(rxData.patient?.mobile || "");
      setPatientEmail(rxData.patient?.email || "");
      setPatientDob(rxData.patient?.dob || "");
      setPatientAge(rxData.patient?.age || "");
      setPatientGender(rxData.patient?.gender || "Male");

      setDoctorName(rxData.doctor?.name || "");
      setDoctorMobile(rxData.doctor?.mobile || "");
      setDoctorAddress(rxData.doctor?.address || "");

      setSphRight(rxData.sphRight || ""); setCylRight(rxData.cylRight || ""); setAxisRight(rxData.axisRight || "");
      setSphLeft(rxData.sphLeft || ""); setCylLeft(rxData.cylLeft || ""); setAxisLeft(rxData.axisLeft || "");
      setNvSphRight(rxData.nvSphRight || ""); setNvCylRight(rxData.nvCylRight || ""); setNvAxisRight(rxData.nvAxisRight || "");
      setNvSphLeft(rxData.nvSphLeft || ""); setNvCylLeft(rxData.nvCylLeft || ""); setNvAxisLeft(rxData.nvAxisLeft || "");
      setPdRight(rxData.pdRight || ""); setVaRight(rxData.vaRight || ""); setAddRight(rxData.addRight || "");
      setPdLeft(rxData.pdLeft || ""); setVaLeft(rxData.vaLeft || ""); setAddLeft(rxData.addLeft || "");

      setClSphRight(rxData.clSphRight || ""); setClCylRight(rxData.clCylRight || ""); setClAxisRight(rxData.clAxisRight || "");
      setClSphLeft(rxData.clSphLeft || ""); setClCylLeft(rxData.clCylLeft || ""); setClAxisLeft(rxData.clAxisLeft || "");
      setClNvSphRight(rxData.clNvSphRight || ""); setClNvCylRight(rxData.clNvCylRight || ""); setClNvAxisRight(rxData.clNvAxisRight || "");
      setClNvSphLeft(rxData.clNvSphLeft || ""); setClNvCylLeft(rxData.clNvCylLeft || ""); setClNvAxisLeft(rxData.clNvAxisLeft || "");
      setClAddRight(rxData.clAddRight || ""); setClAddLeft(rxData.clAddLeft || "");

      setTrnSphRight(rxData.trnSphRight || ""); setTrnCylRight(rxData.trnCylRight || ""); setTrnAxisRight(rxData.trnAxisRight || "");
      setTrnSphLeft(rxData.trnSphLeft || ""); setTrnCylLeft(rxData.trnCylLeft || ""); setTrnAxisLeft(rxData.trnAxisLeft || "");
      setTrnNvSphRight(rxData.trnNvSphRight || ""); setTrnNvCylRight(rxData.trnNvCylRight || ""); setTrnNvAxisRight(rxData.trnNvAxisRight || "");
      setTrnNvSphLeft(rxData.trnNvSphLeft || ""); setTrnNvCylLeft(rxData.trnNvCylLeft || ""); setTrnNvAxisLeft(rxData.trnNvAxisLeft || "");
      setTrnAddRight(rxData.trnAddRight || ""); setTrnAddLeft(rxData.trnAddLeft || "");

      setLensTypes(rxData.lensTypes || []);
      setEyeTestRecord(rxData.eyeTestRecord || "Yes");
      setPrescriptionNotes(rxData.prescriptionNotes || "");
    } else {
      clearPrescriptionForm();
    }

    setActiveTab("newOrder");
  };

  const addToCartAction = (product, customConfig = null) => {
    const lensCheck = isLensProduct(product);
    
    // Lens bypass for stock 0 check
    if (!lensCheck && Number(product.quantity) <= 0) return alert(`Out of stock! Quantity available: ${product.quantity}`);
    
    let activePrice = customConfig ? Number(customConfig.retailPrice) : (Number(product.retailPrice) || Number(product.mrp) || 0);
    let activeDiscount = customConfig ? Number(customConfig.discountAmount) : 0;
    let activeDiscountType = customConfig ? customConfig.discountType : "amount";
    let activeDiscountValue = customConfig ? Number(customConfig.discountValue) : 0;
    let activeHsnCode = customConfig ? customConfig.hsnCode : "";
    let activeGstPercent = customConfig ? Number(customConfig.gstPercent) : 0;
    
    const cartIndex = billingCart.findIndex(item => item.id === product.id);
    if (cartIndex !== -1) {
      if (!lensCheck && billingCart[cartIndex].cartQuantity >= Number(product.quantity)) {
        return alert(`Cannot add more. Max stock available: ${product.quantity}`);
      }
      const updated = [...billingCart]; updated[cartIndex].cartQuantity += 1;
      setBillingCart(updated);
    } else {
      setBillingCart([...billingCart, { 
        ...product, 
        retailPrice: activePrice,
        cartQuantity: 1, 
        customDiscount: activeDiscount, 
        discountType: activeDiscountType,
        discountValue: activeDiscountValue,
        hsnCode: activeHsnCode,
        gstPercent: activeGstPercent,
        isCustomItem: false 
      }]);
    }
    setSkuSearchQuery("");

    if (lensCheck) {
      setShowPrescriptionModal(true);
    }
  };

  const handleInjectCustomProduct = () => {
    if (!customItem.productCode || !customItem.productName || !customItem.customPrice) return alert("Fill all custom product fields.");
    
    setBillingCart([...billingCart, {
      id: `CUSTOM_${Date.now()}`, productCode: customItem.productCode.toUpperCase(), productName: customItem.productName,
      mrp: Number(customItem.customPrice), retailPrice: Number(customItem.customPrice), cartQuantity: 1, customDiscount: 0, 
      discountType: "amount", discountValue: 0, hsnCode: "", gstPercent: 0, isCustomItem: true
    }]);

    if (isLensProduct(customItem)) setShowPrescriptionModal(true);
    setCustomItem({ productCode: "", productName: "", customPrice: "" });
  };

  const updateCartQty = (id, newQty) => {
    if (newQty <= 0) { setBillingCart(billingCart.filter(i => i.id !== id)); return; }
    const target = billingCart.find(i => i.id === id);
    const lensCheck = isLensProduct(target);
    
    if (!target.isCustomItem && !lensCheck && newQty > Number(target.quantity) && !editOrderId) {
      return alert(`Cannot add more. Max stock available: ${target.quantity}`);
    }
    setBillingCart(billingCart.map(i => i.id === id ? { ...i, cartQuantity: Number(newQty) } : i));
  };

  const updateCartDiscount = (id, discount) => {
    setBillingCart(billingCart.map(i => i.id === id ? { ...i, customDiscount: Number(discount), discountValue: Number(discount), discountType: 'amount' } : i));
  };

  const toggleLensType = (type) => {
    if (lensTypes.includes(type)) {
      setLensTypes(lensTypes.filter(t => t !== type));
    } else {
      setLensTypes([...lensTypes, type]);
    }
  };

  const financials = useMemo(() => {
    let subtotal = 0; let totalItemDiscount = 0; let mrpRetailDiff = 0;
    billingCart.forEach(item => { 
      const qty = Number(item.cartQuantity);
      const retail = Number(item.retailPrice) || 0;
      const mrp = Number(item.mrp) || retail; 
      subtotal += retail * qty; 
      totalItemDiscount += (Number(item.customDiscount) || 0); 
      mrpRetailDiff += (mrp - retail) * qty;
    });
    
    let baseAfterItemDisc = subtotal - totalItemDiscount;

    let calculatedOverallDisc = 0;
    const oDiscVal = Number(overallDiscountValue) || 0;
    if (overallDiscountType === "percent") {
      calculatedOverallDisc = baseAfterItemDisc * (oDiscVal / 100);
    } else {
      calculatedOverallDisc = oDiscVal;
    }

    if (calculatedOverallDisc > baseAfterItemDisc) calculatedOverallDisc = baseAfterItemDisc;
    const baselineBase = baseAfterItemDisc - calculatedOverallDisc;
    const totalDiscount = totalItemDiscount + calculatedOverallDisc;
    const computedTax = taxRule === "exclude" ? baselineBase * (Number(taxPercentage) / 100) : (taxRule === "include" ? baselineBase - (baselineBase / (1 + (Number(taxPercentage) / 100))) : 0);
    
    let netPayable = taxRule === "exclude" ? baselineBase + computedTax : baselineBase;
    const unroundedNetPayable = netPayable;
    netPayable += Number(roundOff) || 0; 
    const totalYouSave = mrpRetailDiff + totalDiscount;

    return { 
      subtotal, totalDiscount, mrpRetailDiff, totalYouSave, computedTax, netPayable, unroundedNetPayable, 
      balanceDue: netPayable - (Number(advancePaid) || 0), overallDiscountApplied: calculatedOverallDisc
    };
  }, [billingCart, taxRule, taxPercentage, advancePaid, roundOff, overallDiscountType, overallDiscountValue]);

  const commitInvoiceTransaction = async (isDirectInvoice = false) => {
    if (!customerName || !customerPhone || !salesperson) return setSystemError("Customer details and Salesperson are required.");
    if (billingCart.length === 0) return setSystemError("Cart is empty.");
    if (isDirectInvoice && financials.balanceDue > 0) return setSystemError("Direct Invoice requires full payment (Balance Due must be 0).");
    if (showPrescriptionModal && doctorName === "") return setSystemError("Doctor Name is mandatory in prescription.");
    if ((paymentMode === "UPI / GPay" || paymentMode === "Credit Card") && !posPaymentDetails) {
        return setSystemError(`Please enter a Transaction or Card Number for ${paymentMode}.`);
    }
    
    setIsProcessing(true); setSystemError(null);
    
    let invoiceNumber = orderReference;
    
    // NEW INVOICE NUMBER FORMATTING (e.g., 26-1001)
    if (!editOrderId && !invoiceNumber) {
      const yearPrefix = `${new Date().getFullYear().toString().slice(-2)}-`;
      let nextInv = 1001;
      
      const existingOpt = salesHistoryData
        .filter(s => s.invoiceNo && s.invoiceNo.startsWith(yearPrefix))
        .map(s => parseInt(s.invoiceNo.replace(yearPrefix, ""), 10))
        .filter(n => !isNaN(n));
        
      if (existingOpt.length > 0) {
        nextInv = Math.max(...existingOpt) + 1;
      }
      invoiceNumber = `${yearPrefix}${nextInv}`;
    }

    const finalDeliveryDate = deliveryDate || new Date().toISOString().split("T")[0];
    const isPending = !isDirectInvoice && (Number(advancePaid) >= 0 && financials.balanceDue > 0);
    const initialPaid = isDirectInvoice ? financials.netPayable : Number(advancePaid);
    
    try {
      // 1. Sanitize Customer Data
      const customerPayload = JSON.parse(JSON.stringify({
        name: customerName, phone: customerPhone, phone2: customerPhone2, dob: customerDob, anniversary: customerAnniversary, company: customerCompany, address: customerAddress, locality: customerLocality, state: customerState, pincode: customerPincode, notes: customerNotes, lastUpdated: new Date().toISOString()
      }));

      await setDoc(doc(db, "stores", activeBranchId, "customers", customerPhone), customerPayload, { merge: true });

      let rxPayload = null;
      let cleanRxPayload = null;
      const hasLens = billingCart.some(i => isLensProduct(i));
      
      if (hasLens || patientName || sphLeft || sphRight || clSphLeft || clSphRight) {
        const linkedLensProducts = billingCart
          .filter(i => isLensProduct(i))
          .map(i => ({ name: i.productName, price: Number(i.retailPrice), qty: Number(i.cartQuantity) }));

        rxPayload = {
          patient: { name: patientName, mobile: patientMobile, email: patientEmail, dob: patientDob, age: patientAge, gender: patientGender },
          doctor: { name: doctorName, mobile: doctorMobile, address: doctorAddress },
          sphRight, cylRight, axisRight, pdRight, vaRight, addRight,
          sphLeft, cylLeft, axisLeft, pdLeft, vaLeft, addLeft,
          nvSphRight, nvCylRight, nvAxisRight, nvSphLeft, nvCylLeft, nvAxisLeft,
          clSphRight, clCylRight, clAxisRight, clAddRight, clSphLeft, clCylLeft, clAxisLeft, clAddLeft,
          clNvSphRight, clNvCylRight, clNvAxisRight, clNvSphLeft, clNvCylLeft, clNvAxisLeft,
          trnSphRight, trnCylRight, trnAxisRight, trnAddRight, trnSphLeft, trnCylLeft, trnAxisLeft, trnAddLeft,
          trnNvSphRight, trnNvCylRight, trnNvAxisRight, trnNvSphLeft, trnNvCylLeft, trnNvAxisLeft,
          lensTypes, eyeTestRecord, prescriptionNotes, linkedLensProducts,
          timestamp: new Date().toISOString()
        };

        // 2. Sanitize Rx Payload
        cleanRxPayload = JSON.parse(JSON.stringify(rxPayload));

        if ((patientName || doctorName) && !editOrderId && cleanRxPayload) {
           await addDoc(collection(db, "stores", activeBranchId, "prescriptions"), cleanRxPayload);
        }
      }

      // 3. Sanitize Items Payload Defaults
      // 3. Sanitize Items Payload Defaults
      const itemsList = billingCart.map(i => ({ 
        productCode: i.productCode || "", 
        productName: i.productName || "Unknown Product",
        productType: i.productType || "", // <-- ADD THIS LINE
        quantity: Number(i.cartQuantity) || 1, 
        mrp: Number(i.mrp || i.retailPrice) || 0, 
        retailPrice: Number(i.retailPrice) || 0, 
        discount: Number(i.customDiscount) || 0,
        discountType: i.discountType || "amount",
        discountValue: Number(i.discountValue) || Number(i.customDiscount) || 0,
        hsnCode: i.hsnCode || "",
        gstPercent: Number(i.gstPercent) || 0
      }));
      if (editOrderId) {
        const oldOrder = salesHistoryData.find(o => o.id === editOrderId);
        let updatedHistory = oldOrder?.checkout?.paymentHistory || [];
        
        if (updatedHistory.length > 0) {
          updatedHistory[0] = { ...updatedHistory[0], amount: initialPaid, mode: paymentMode, details: posPaymentDetails };
        } else {
          updatedHistory = [{ amount: initialPaid, mode: paymentMode, details: posPaymentDetails, date: new Date().toISOString() }];
        }

        const reCalculatedTotalPaid = updatedHistory.reduce((acc, curr) => acc + (Number(curr.amount) || 0), 0);

        // 4. Sanitize Update Payload
        const updatePayload = JSON.parse(JSON.stringify({
          salesperson,
          orderStatus: isPending ? "Pending" : "Completed",
          customer: { name: customerName, phone: customerPhone, phone2: customerPhone2, address: customerAddress, state: customerState, dob: customerDob, anniversary: customerAnniversary, company: customerCompany, locality: customerLocality, pincode: customerPincode, notes: customerNotes },
          prescription: cleanRxPayload,
          checkout: { 
            taxRule, taxPercentage, paymentMode, advancePaid: Number(advancePaid) || 0, roundOff: Number(roundOff) || 0, overallDiscountType, overallDiscountValue: Number(overallDiscountValue) || 0,
            deliveryDate: finalDeliveryDate, placementDate: salesDate,
            totalAmountPaid: reCalculatedTotalPaid,
            paymentHistory: updatedHistory
          },
          items: itemsList,
          financials: { subtotal: financials.subtotal, totalDiscount: financials.totalDiscount, totalYouSave: financials.totalYouSave, computedTax: financials.computedTax, netPayable: financials.netPayable, balanceDue: financials.netPayable - reCalculatedTotalPaid }
        }));

        await updateDoc(doc(db, "stores", activeBranchId, "sales", editOrderId), updatePayload);
        
      } else {
        await runTransaction(db, async (txn) => {
          const inventoryDocsToUpdate = [];
          for (const item of billingCart) {
            if (item.isCustomItem) continue;
            if (isLensProduct(item)) continue; // Bypass stock deduction for lenses entirely if needed.
            
            const ref = doc(db, "stores", activeBranchId, "inventory", item.id);
            const snap = await txn.get(ref);
            if (!snap.exists()) throw new Error(`Product missing from inventory: ${item.productName}`);
            if (snap.data().quantity < item.cartQuantity) throw new Error(`Low stock: ${item.productName} (Available: ${snap.data().quantity})`);
            inventoryDocsToUpdate.push({ ref, newQuantity: snap.data().quantity - item.cartQuantity });
          }
          inventoryDocsToUpdate.forEach((invDoc) => { txn.update(invDoc.ref, { quantity: invDoc.newQuantity }); });
          
          const newSaleRef = doc(collection(db, "stores", activeBranchId, "sales"));
          
          // 5. Sanitize New Sale Payload
          const salesPayload = JSON.parse(JSON.stringify({
            invoiceNo: invoiceNumber, branch: resolvedBranchName, timestamp: new Date().toISOString(), 
            orderStatus: isPending ? "Pending" : "Completed", salesperson,
            customer: { name: customerName, phone: customerPhone, phone2: customerPhone2, address: customerAddress, state: customerState, dob: customerDob, anniversary: customerAnniversary, company: customerCompany, locality: customerLocality, pincode: customerPincode, notes: customerNotes },
            prescription: cleanRxPayload,
            checkout: { 
              taxRule, taxPercentage, paymentMode, advancePaid: Number(advancePaid) || 0, roundOff: Number(roundOff) || 0, overallDiscountType, overallDiscountValue: Number(overallDiscountValue) || 0,
              deliveryDate: finalDeliveryDate, placementDate: salesDate,
              totalAmountPaid: initialPaid,
              paymentHistory: [{ amount: initialPaid, mode: paymentMode, details: posPaymentDetails, date: new Date().toISOString() }]
            },
            items: itemsList,
            financials: { subtotal: financials.subtotal, totalDiscount: financials.totalDiscount, totalYouSave: financials.totalYouSave, computedTax: financials.computedTax, netPayable: financials.netPayable, balanceDue: financials.balanceDue }
          }));

          txn.set(newSaleRef, salesPayload);
        });
        setLastInvoiceNo(invoiceNumber);
      }

      resetForm();
    } catch (e) { setSystemError(e.message); } 
    finally { setIsProcessing(false); }
  };

  const triggerCompletionFlow = (order) => {
    setCompletionPaymentMode("CASH");
    setCompletionPaymentDetails("");
    setCompletionRoundOff("");
    setCompletingOrder(order);
  };

  const handleFinalizePendingOrder = async () => {
    if (!completingOrder) return;
    try {
      const manualRoundOff = Number(completionRoundOff) || 0;
      const targetPaymentAmount = completingOrder.financials.balanceDue - manualRoundOff;
      const history = completingOrder.checkout?.paymentHistory || [];
      
      history.push({ 
        amount: targetPaymentAmount, 
        mode: completionPaymentMode, 
        details: completionPaymentDetails,
        date: new Date().toISOString() 
      });

      const newTotalPaid = (completingOrder.checkout?.totalAmountPaid || 0) + targetPaymentAmount;
      const accumulatedRoundOff = (completingOrder.checkout?.roundOff || 0) + manualRoundOff;

      await updateDoc(doc(db, "stores", activeBranchId, "sales", completingOrder.id), { 
        orderStatus: "Completed", 
        "financials.balanceDue": 0,
        "checkout.totalAmountPaid": newTotalPaid,
        "checkout.roundOff": accumulatedRoundOff,
        "checkout.paymentHistory": history
      });
      alert("Payment cleared & Order marked as Completed!");
      setCompletingOrder(null);
    } catch (e) { console.error(e); }
  };

  // Unified function to open the correct PDF route in a new tab
 const handleViewPDF = (invoiceNo, docType) => {
    // Pass invoiceNo instead of order.id
    if (!activeBranchId || !invoiceNo) {
      alert("Missing Data");
      return;
    }

    // This will generate: localhost:3000/receipt/RAJABAZAR/26-1001
    const url = `/${docType}/${activeBranchId}/${invoiceNo}`;
    window.open(url, '_blank');
  };
  
  const handleDeleteOrder = async (orderId) => {
    if (!window.confirm("Delete this order? Stock quantities will be restored to inventory. This action cannot be undone.")) return;
    
    setIsProcessing(true);
    setSystemError(null);

    try {
      const orderToRestore = salesHistoryData.find(o => o.id === orderId);
      if (!orderToRestore) throw new Error("Order not found in system memory.");

      await runTransaction(db, async (txn) => {
        const inventoryDocsToUpdate = [];
        for (const item of (orderToRestore.items || [])) {
          if (!item.productCode) continue; 
          const matchedProduct = products.find(p => p.productCode === item.productCode);
          if (!matchedProduct || isLensProduct(matchedProduct)) continue; // Bypass lens restore if stock not managed

          const invRef = doc(db, "stores", activeBranchId, "inventory", matchedProduct.id);
          const invSnap = await txn.get(invRef);

          if (invSnap.exists()) {
            inventoryDocsToUpdate.push({
              ref: invRef,
              newQuantity: Number(invSnap.data().quantity || 0) + Number(item.quantity || 0)
            });
          }
        }

        inventoryDocsToUpdate.forEach((invDoc) => {
          txn.update(invDoc.ref, { quantity: invDoc.newQuantity });
        });

        const orderRef = doc(db, "stores", activeBranchId, "sales", orderId);
        txn.delete(orderRef);
      });

      alert("Order deleted and stock safely restored!");
    } catch (e) { 
      console.error("Deletion Error:", e);
      setSystemError("Failed to delete order & restore stock: " + e.message); 
    } finally {
      setIsProcessing(false);
    }
  };

  // --- UPDATED WHATSAPP LOGIC ---
  const handleSendWhatsapp = (order, docType) => {
    if(!order) return;
    const phone = order.customer?.phone || "";
    if(phone.length < 10) return alert("Customer does not have a valid phone number.");

    const netPayable = order.financials?.netPayable || 0;
    const paid = order.checkout?.totalAmountPaid || order.checkout?.advancePaid || 0;
    const balance = order.financials?.balanceDue || 0;
    const path = docType === 'advance' ? 'advance-receipt' : 'receipt';

    let message = `Hello ${order.customer?.name || "Customer"},\n\n`;

    if (docType === 'ready') {
      message += `Great news! Your order from Shruti Eye Care & Opticals is now READY for pickup.\n\n`;
      message += `Order ID: ${order.invoiceNo}\n`;
      if (balance > 0) message += `Balance Due: Rs ${balance.toFixed(2)}\n`;
      message += `\nFor queries, please contact us at: ${activeStoreMobNumber}`;
    } else {
      message += `Thank you for shopping with Shruti Eye Care & Opticals!\n\n`;
      message += `Your Order ID is: ${order.invoiceNo}\n`;
      message += `Net Amount: Rs ${netPayable.toFixed(2)}\n`;
      message += `Amount Paid: Rs ${paid.toFixed(2)}\n`;
      if (balance > 0) message += `Balance Due: Rs ${balance.toFixed(2)}\n`;
      message += `\nView your PDF receipt here: ${window.location.origin}/${path}/${activeBranchId}/${order.invoiceNo}\n`;
      message += `\nFor queries, please contact us at: ${activeStoreMobNumber}`;
    }

    const url = `https://wa.me/91${phone}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
    setShowContactModal(false);
  };

  // --- UPDATED SMS LOGIC ---
  const handleSendSMS = (order, docType) => {
    if(!order) return;
    const phone = order.customer?.phone || "";
    if(phone.length < 10) return alert("Customer does not have a valid phone number.");

    const netPayable = order.financials?.netPayable || 0;
    const paid = order.checkout?.totalAmountPaid || order.checkout?.advancePaid || 0;
    const balance = order.financials?.balanceDue || 0;

    let message = `Hello ${order.customer?.name || "Customer"},\n`;

    if (docType === 'ready') {
       message += `Your order (${order.invoiceNo}) from Shruti Eye Care is READY for pickup.\n`;
       if (balance > 0) message += `Balance Due: Rs ${balance.toFixed(2)}\n`;
    } else {
       message += `Thank you for shopping with Shruti Eye Care!\n`;
       message += `Order ID: ${order.invoiceNo}\n`;
       message += `Paid: Rs ${paid.toFixed(2)}\n`;
       if (balance > 0) message += `Balance: Rs ${balance.toFixed(2)}\n`;
    }

    const encodedMessage = encodeURIComponent(message);
    const smsLink = `sms:+91${phone}?body=${encodedMessage}`;
    window.location.href = smsLink;
    setShowContactModal(false);
  };

// --- HTML TEMPLATE: ORDER FORM ---
  const handlePrintOrderForm = (order) => {
    const printWindow = window.open('', '_blank');
    
    const dateObj = new Date(order.timestamp);
    const orderDateStr = dateObj.toLocaleDateString('en-GB');
    const deliveryDateRaw = order.checkout?.deliveryDate || dateObj.toISOString().split("T")[0];
    const deliveryDateStr = deliveryDateRaw.split("-").reverse().join("-");

const itemsHtml = (order.items || []).map((item, idx) => {
      // 1. Safely extract and format strings (add spaces for separation)
      const pType = item.productType ? item.productType.toUpperCase() + " " : "";
      const pCode = item.productCode ? item.productCode.toUpperCase() + " " : "";
      const pName = item.productName ? item.productName.toUpperCase() : "";

      // 2. Check if the product is a lens
      const pNameLower = item.productName?.toLowerCase() || "";
      const pCodeLower = item.productCode?.toLowerCase() || "";
      const isLens = pNameLower.includes("lens") || pCodeLower.includes("lens") || item.productType === "Glass" || item.productType === "Lens" || item.productType === "Contact Lens";

      // 3. Apply the formatting rule: hide productCode if it's a lens
      const displayTitle = isLens 
        ? `${pType}${pName}`.trim() 
        : `${pType}${pCode}${pName}`.trim();

      // 4. Return the HTML row
      return `
      <tr>
      <td class="sl" style="vertical-align:top; font-weight:normal;">${idx + 1}</td>
      <td style="font-weight:normal;">
      ${displayTitle}
      </td>
      </tr>
      `;
    }).join('');

    // Dynamically insert Prescription Table below Items if it exists
    let rxHtml = '';
    const rx = order.prescription;
    if (rx && (rx.sphRight || rx.sphLeft || rx.clSphRight || rx.clSphLeft)) {
        rxHtml = `
        <div class="prescriptionWrapper" style="margin-top: 25px;">
            <h3 style="margin-bottom: 12px; font-size: 18px; font-weight: bold; text-decoration: underline; color: #000;">PRESCRIPTION DETAILS</h3>
            <table class="prescription" style="width: 100%; border-collapse: collapse; text-align: center;">
            <tr>
            <td style="border:1px solid #000; padding:10px;"></td>
            <td colspan="5" class="eyeTitle" style="border:1px solid #000; padding:10px; font-weight:bold;">✓ RIGHT EYE (OD)</td>
            <td colspan="5" class="eyeTitle" style="border:1px solid #000; padding:10px; font-weight:bold;">✓ LEFT EYE (OS)</td>
            </tr>
            <tr style="background:#f2f2f2;">
            <td style="border:1px solid #000; padding:8px;"></td>
            <td style="border:1px solid #000; padding:8px; font-weight:bold;">SPH</td><td style="border:1px solid #000; padding:8px; font-weight:bold;">CYL</td><td style="border:1px solid #000; padding:8px; font-weight:bold;">AXIS</td><td style="border:1px solid #000; padding:8px; font-weight:bold;">PD</td><td style="border:1px solid #000; padding:8px; font-weight:bold;">VA</td>
            <td style="border:1px solid #000; padding:8px; font-weight:bold;">SPH</td><td style="border:1px solid #000; padding:8px; font-weight:bold;">CYL</td><td style="border:1px solid #000; padding:8px; font-weight:bold;">AXIS</td><td style="border:1px solid #000; padding:8px; font-weight:bold;">PD</td><td style="border:1px solid #000; padding:8px; font-weight:bold;">VA</td>
            </tr>
            <tr>
            <td style="border:1px solid #000; padding:10px; font-weight:normal;">DV</td>
            <td style="border:1px solid #000; padding:10px; font-weight:normal;">${rx.sphRight || '-'}</td><td style="border:1px solid #000; padding:10px; font-weight:normal;">${rx.cylRight || '-'}</td><td style="border:1px solid #000; padding:10px; font-weight:normal;">${rx.axisRight || '-'}</td><td style="border:1px solid #000; padding:10px; font-weight:normal;">${rx.pdRight || '-'}</td><td style="border:1px solid #000; padding:10px; font-weight:normal;">${rx.vaRight || '-'}</td>
            <td style="border:1px solid #000; padding:10px; font-weight:normal;">${rx.sphLeft || '-'}</td><td style="border:1px solid #000; padding:10px; font-weight:normal;">${rx.cylLeft || '-'}</td><td style="border:1px solid #000; padding:10px; font-weight:normal;">${rx.axisLeft || '-'}</td><td style="border:1px solid #000; padding:10px; font-weight:normal;">${rx.pdLeft || '-'}</td><td style="border:1px solid #000; padding:10px; font-weight:normal;">${rx.vaLeft || '-'}</td>
            </tr>
            <tr>
            <td style="border:1px solid #000; padding:10px; font-weight:normal;">NV</td>
            <td style="border:1px solid #000; padding:10px; font-weight:normal;">${rx.nvSphRight || '-'}</td><td style="border:1px solid #000; padding:10px; font-weight:normal;">${rx.nvCylRight || '-'}</td><td style="border:1px solid #000; padding:10px; font-weight:normal;">${rx.nvAxisRight || '-'}</td><td style="border:1px solid #000; padding:10px; font-weight:normal;">-</td><td style="border:1px solid #000; padding:10px; font-weight:normal;">-</td>
            <td style="border:1px solid #000; padding:10px; font-weight:normal;">${rx.nvSphLeft || '-'}</td><td style="border:1px solid #000; padding:10px; font-weight:normal;">${rx.nvCylLeft || '-'}</td><td style="border:1px solid #000; padding:10px; font-weight:normal;">${rx.nvAxisLeft || '-'}</td><td style="border:1px solid #000; padding:10px; font-weight:normal;">-</td><td style="border:1px solid #000; padding:10px; font-weight:normal;">-</td>
            </tr>
            <tr class="addRow">
            <td style="border:1px solid #000; padding:10px; font-weight:normal;">ADD</td>
            <td colspan="5" style="border:1px solid #000; padding:10px; text-align:left; font-weight:bold; color:#b40000;">${rx.addRight || '-'}</td>
            <td colspan="5" style="border:1px solid #000; padding:10px; text-align:left; font-weight:bold; color:#b40000;">${rx.addLeft || '-'}</td>
            </tr>
            <tr>
            <td colspan="11" class="notes" style="border:1px solid #000; padding:15px; text-align:left; font-weight:normal;">
            <strong style="font-weight:bold; text-decoration:underline;">Prescription Notes:</strong><br/>
            ${rx.prescriptionNotes || 'As directed by Optometrist.'}
            </td>
            </tr>
            </table>
        </div>`;
    }

    const htmlContent = `
    <!DOCTYPE html>
    <html lang="en">
    <head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Order Form - ${order.invoiceNo}</title>
    <style>
    *{ margin:0; padding:0; box-sizing:border-box; font-family:Arial, Helvetica, sans-serif; color: #000; }
    body{ background:#fff; font-weight: normal; }
    .page{ width:100%; min-height:100vh; margin:auto; background:white; padding:15mm; }
    .header{ display:flex; justify-content:space-between; align-items:flex-start; border-bottom:2px solid #000; padding-bottom:15px; }
    .logo{ width:140px; display:flex; justify-content:center; align-items:center; }
    .logo img{ width:120px; }
    .company{ flex:1; text-align:right; }
    .company h1{ font-size:24px; font-weight:bold; letter-spacing:.5px; margin-bottom:5px; }
    .company p{ font-size:14px; line-height:1.3; font-weight: normal; }
    .company .small{ margin-top:8px; font-size:13px; font-weight: normal; }
    .orderTitle{ text-align:center; margin-top:20px; margin-bottom:25px; }
    .orderTitle h2{ font-size:24px; font-weight:bold; text-decoration:underline; }
    .customerSection{ display:flex; justify-content:space-between; margin-bottom:25px; }
    .customerLeft{ width:55%; font-size:15px; font-weight:normal; }
    .customerLeft strong{ font-size:16px; font-weight:bold; }
    .customerRight{ width:35%; font-size:15px; line-height:1.6; font-weight:normal; }
    .mainTable{ width:100%; border-collapse:collapse; }
    .mainTable th, .mainTable td{ border:1px solid #000; padding:10px; font-size:15px; font-weight: normal;}
    .mainTable th{ text-align:left; font-size:16px; font-weight: bold; background:#f2f2f2; }
    .sl{ width:60px; text-align:center; }
    @page{ size:A4; margin:10mm; }
    @media print{ body{ background:white; } .page{ margin:0; padding:10mm; width:100%; box-shadow:none; } }
    </style>
    </head>
    <body>
    <div class="page">
    <div class="header">
    <div class="logo">
    <img src="${window.location.origin}/logo192.png">
    </div>
    <div class="company">
    <h1>SHRUTI EYE CARE & OPTICALS</h1>
    <p>${activeStoreAdress}</p>
    <p class="small">
    Mobile No : 9470835831, 9939605949<br>
    Landline No : ${activeStoreNumber}<br>
    Email ID : shrutieyecare16022021@gmail.com<br>
    GST Number : 10CYXPK1491E2ZC
    </p>
    </div>
    </div>
    <div class="orderTitle">
    <h2>ORDER FORM</h2>
    </div>
    <div class="customerSection">
    <div class="customerLeft">
    <strong>Customer Name :</strong> &nbsp; ${order.customer?.name?.toUpperCase() || 'WALK-IN'}
    </div>
    <div class="customerRight">
    Order Number : ${order.invoiceNo}<br>
    Date of Order : ${orderDateStr}<br>
    Date of Delivery : ${deliveryDateStr}
    </div>
    </div>
    <table class="mainTable">
    <tr>
    <th class="sl">SL NO</th>
    <th>PRODUCT DETAILS</th>
    </tr>
    ${itemsHtml}
    </table>
    
    ${rxHtml}

    </div>
    <script>
      window.addEventListener('load', function() {
        setTimeout(function() { window.print(); setTimeout(function() { window.close(); }, 500); }, 300);
      });
    </script>
    </body>
    </html>
    `;

    printWindow.document.write(htmlContent);
    printWindow.document.close();
  };

  const handlePrintPrescription = (order) => {
    if (!order.prescription) return alert("No Eye Diagnostic Parameters found for this order.");
    const includeSignatures = window.confirm("Include Optometrist and Authorized Signatures in the printout?");
    const printWindow = window.open('', '_blank');
    
    const record = order.prescription;
    const dateObj = new Date(record.timestamp || order.timestamp || Date.now());
    const dateStr = dateObj.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
    const nextMonthStr = new Date(dateObj.setMonth(dateObj.getMonth() + 1)).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
    
    const htmlContent = `
    <!DOCTYPE html>
    <html lang="en">
    <head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Prescription - ${record.patient?.name || order.customer?.name || 'Patient'}</title>
    <style>
      * { margin:0; padding:0; box-sizing:border-box; font-family: 'Segoe UI', Arial, sans-serif; font-weight: normal; color:#000; }
      @page { size: A4; margin: 10mm; }
      body { background: #fff; color: #000; -webkit-print-color-adjust: exact; padding: 15mm; }
      .a4-page { width: 100%; margin: 0 auto; background: white; }

      .header {
        position: relative;
        text-align: center;
        border-bottom: 2px solid #16205f;
        padding-bottom: 15px;
        margin-bottom: 25px;
        min-height: 90px;
      }

      .logo {
        position: absolute;
        left: 0;
        top: 0;
      }

      .logo img {
        width: 100px;
        height: 100px;
        object-fit: contain;
      }

      .header-content {
        display: inline-block;
        text-align: center;
        margin-right: 20px;
      }

      .clinic-name {
        font-size: 26px;
        font-weight: bold;
        color: #16205f;
        text-transform: uppercase;
        letter-spacing: 1px;
        margin-bottom: 5px;
      }

      .store-address {
        font-size: 14px;
        color: #000;
        font-weight: normal;
        margin-bottom: 8px;
      }

      .tagline {
        color: #000;
        font-size: 13px;
        font-weight: normal;
        margin-bottom: 15px;
      }

      .title {
        display: inline-block;
        font-size: 18px;
        font-weight: bold;
        color: #fff;
        background: #16205f;
        padding: 8px 25px;
        border-radius: 20px;
        text-transform: uppercase;
      }
      .patient-section { display: flex; justify-content: space-between; margin-bottom: 25px; gap: 25px; }
      .info-box { border: 1px solid #000; border-radius: 8px; padding: 15px; flex: 1; background: #fafafa; text-align: left; }
      .info-box h4 { font-size: 14px; font-weight: bold; color: #000; text-transform: uppercase; margin-bottom: 12px; border-bottom: 1px solid #000; padding-bottom: 5px; text-align: left; }
      .info-row { display: flex; justify-content: space-between; margin-bottom: 8px; font-size: 14px; text-align: left; }
      .info-row strong { color: #000; font-weight: bold; }
      
      .section { border: 1px solid #000; border-radius: 8px; margin-bottom: 25px; overflow: hidden; }
      .section-title { background: #f0f4f8; padding: 12px 15px; font-size: 15px; font-weight: bold; border-bottom: 1px solid #000; color: #16205f; text-transform: uppercase; text-align: left; }
      
      table { width: 100%; border-collapse: collapse; }
      th { background: #fafafa; font-size: 13px; font-weight: bold; padding: 10px; border: 1px solid #000; text-transform: uppercase; color: #000; }
      td { text-align: center; padding: 10px; border: 1px solid #000; font-size: 14px; font-weight: normal; color: #000; }
      
      .notes { padding: 15px; border: 1px dashed #000; border-radius: 8px; font-size: 14px; font-weight: normal; line-height: 1.6; background: #fffdf9; margin-bottom: 25px; text-align: left; }
      .notes h3 { margin-bottom: 8px; font-size: 15px; font-weight: bold; color: #16205f; text-transform: uppercase; text-decoration: underline; }
      
      .footer-reminder { display: flex; justify-content: space-between; align-items: center; border: 1px solid #000; border-radius: 8px; padding: 15px 20px; background: #f8f9fa; margin-bottom: 30px; }
      .footer-reminder .text { font-size: 14px; color: #000; text-transform: uppercase; font-weight: bold; }
      .footer-reminder .date { font-size: 20px; font-weight: bold; color: #b40000; }
      
      .signature-area { display: flex; justify-content: space-between; margin-top: 50px; padding: 0 20px; }
      .signature { text-align: left; width: 220px; font-size: 14px; color: #000; font-weight: bold; }
      .signature-line { border-top: 1px solid #000; margin-bottom: 8px; }
      
      .footer { text-align: center; margin-top: 40px; color: #000; font-size: 12px; font-weight: normal; border-top: 1px solid #000; padding-top: 15px; }
    </style>
    </head>
    <body>
      <div class="a4-page">
      </br>
      <div class="header">
        <div class="logo">
          <img src="${window.location.origin}/logo192.png" alt="Logo" />
        </div>

        <div class="header-content">
          <div class="clinic-name">Shruti Eye Care & Opticals</div>

          <div class="store-address">  ${activeStoreAdress}</br>
            Mobile No: 9470835831, 9939605949 | Landline: ${activeStoreNumber}
          </div>

          <div class="tagline">
            Complete Eye Care • Computerized Eye Testing • Contact Lens • Premium Frames
          </div>

          <div class="title">Eye Test Prescription</div>
        </div>
      </div>

        <div class="patient-section">
          <div class="info-box">
            <h4>Patient Profile</h4>
            <div class="info-row"><span>Name:</span> <strong>${record.patient?.name || order.customer?.name || 'Walk-in Patient'}</strong></div>
            <div class="info-row"><span>Mobile:</span> <strong>${record.patient?.mobile || order.customer?.phone || 'N/A'}</strong></div>
            <div class="info-row"><span>Age / Gender:</span> <strong>${record.patient?.age || '-'} / ${record.patient?.gender || '-'}</strong></div>
          </div>
          <div class="info-box">
            <h4>Clinical Details</h4>
            <div class="info-row"><span>Date:</span> <strong>${dateStr}</strong></div>
            <div class="info-row"><span>Optometrist:</span> <strong>${record.doctor?.name || 'Shruti Eye Care'}</strong></div>
            <div class="info-row"><span>Lens Advised:</span> <strong>${record.lensTypes?.join(', ') || 'As per prescription'}</strong></div>
          </div>
        </div>

        <div class="section">
          <div class="section-title">Optical Measurement Matrix</div>
          <table>
            <tr>
              <th style="background:#eef2f6;"></th>
              <th colspan="5">✓ RIGHT EYE (OD)</th>
              <th colspan="5">✓ LEFT EYE (OS)</th>
            </tr>
            <tr>
              <th style="background:#eef2f6;"></th>
              <th>SPH</th><th>CYL</th><th>AXIS</th><th>PD</th><th>VA</th>
              <th>SPH</th><th>CYL</th><th>AXIS</th><th>PD</th><th>VA</th>
            </tr>
            <tr>
              <td style="background:#eef2f6; font-weight:bold;">DV</td>
              <td>${record.sphRight || '-'}</td><td>${record.cylRight || '-'}</td><td>${record.axisRight || '-'}</td><td>${record.pdRight || '-'}</td><td>${record.vaRight || '-'}</td>
              <td>${record.sphLeft || '-'}</td><td>${record.cylLeft || '-'}</td><td>${record.axisLeft || '-'}</td><td>${record.pdLeft || '-'}</td><td>${record.vaLeft || '-'}</td>
            </tr>
            <tr>
              <td style="background:#eef2f6; font-weight:bold;">NV</td>
              <td>${record.nvSphRight || '-'}</td><td>${record.nvCylRight || '-'}</td><td>${record.nvAxisRight || '-'}</td><td>-</td><td>-</td>
              <td>${record.nvSphLeft || '-'}</td><td>${record.nvCylLeft || '-'}</td><td>${record.nvAxisLeft || '-'}</td><td>-</td><td>-</td>
            </tr>
            <tr>
              <td style="background:#eef2f6; font-weight:bold;">ADD</td>
              <td colspan="5" style="color:#b40000; font-weight:bold; text-align:left;">${record.addRight || '-'}</td>
              <td colspan="5" style="color:#b40000; font-weight:bold; text-align:left;">${record.addLeft || '-'}</td>
            </tr>
          </table>
        </div>

        ${(record.clSphRight || record.clSphLeft) ? `
        <div class="section">
          <div class="section-title">Contact Lens Specification</div>
          <table>
            <tr><th style="background:#eef2f6;">EYE</th><th>SPH</th><th>CYL</th><th>AXIS</th></tr>
            <tr><td style="background:#eef2f6; font-weight:bold;">RIGHT (OD)</td><td>${record.clSphRight || '-'}</td><td>${record.clCylRight || '-'}</td><td>${record.clAxisRight || '-'}</td></tr>
            <tr><td style="background:#eef2f6; font-weight:bold;">LEFT (OS)</td><td>${record.clSphLeft || '-'}</td><td>${record.clCylLeft || '-'}</td><td>${record.clAxisLeft || '-'}</td></tr>
          </table>
        </div>` : ''}

        <div class="notes">
          <h3>Clinical Remarks</h3>
          <p>${record.prescriptionNotes || "• Use prescribed glasses regularly to prevent eye strain.<br>• Maintain proper screen distance and take breaks.<br>• Please bring this card on your next visit."}</p>
        </div>

        <div class="footer-reminder">
          <div class="text">Recommended Next Eye Checkup By:</div>
          <div class="date">${nextMonthStr}</div>
        </div>

        ${includeSignatures ? `
        <div class="signature-area">
          <div class="signature"><div class="signature-line"></div>Optometrist Signature</div>
          <div class="signature"><div class="signature-line"></div>Authorized Signatory</div>
        </div>
        ` : ''}

        <div class="footer">
          © Shruti Eye Care & Opticals |${activeStoreAdress}
        </div>
      </div>
      <script>
        window.addEventListener('load', function() {
          setTimeout(function() {
            window.print();
            setTimeout(function() { window.close(); }, 500);
          }, 300);
        });
      </script>
    </body>
    </html>
    `;

    printWindow.document.write(htmlContent);
    printWindow.document.close();
  };

const handlePrintReceipt = (order, type = 'final') => {
    const printWindow = window.open('', '_blank');
    const isAdvance = type === 'advance';
    const titleText = isAdvance ? "ADVANCE RECEIPT" : "FINAL INVOICE";
    
    const pad = (n) => n < 10 ? '0' + n : n;
    const dateObj = new Date(order.timestamp);
    const orderDateStr = `${pad(dateObj.getDate())}-${pad(dateObj.getMonth() + 1)}-${dateObj.getFullYear()}`;
    const paymentDateStr = `${orderDateStr} ${pad(dateObj.getHours())}:${pad(dateObj.getMinutes())}`;
    const deliveryDateRaw = order.checkout?.deliveryDate || dateObj.toISOString().split("T")[0];
    const deliveryDateStr = deliveryDateRaw.split("-").reverse().join("-");
    
    const grossTotal = order.financials?.subtotal || 0;
    
    // ISOLATING ITEM DISCOUNTS FROM OVERALL OFFER DISCOUNTS
    let actualItemDiscount = 0;
    let mrpSavings = 0;
    (order.items || []).forEach(i => {
      actualItemDiscount += Number(i.discount || 0);
      const rPrice = Number(i.retailPrice) || 0;
      const mPrice = Number(i.mrp) || rPrice;
      mrpSavings += (mPrice - rPrice) * (Number(i.quantity) || 1);
    });

    const offerDiscountVal = Number(order.checkout?.overallDiscountValue || 0); 
    const isPercent = order.checkout?.overallDiscountType === 'percent';
    
    let computedOfferDisc = 0;
    if (isPercent) {
      computedOfferDisc = (grossTotal - actualItemDiscount) * (offerDiscountVal / 100);
    } else {
      computedOfferDisc = offerDiscountVal;
    }

    if (computedOfferDisc > (grossTotal - actualItemDiscount)) {
      computedOfferDisc = (grossTotal - actualItemDiscount);
    }

    const netAmount = order.financials?.netPayable || 0;
    const roundOffVal = order.checkout?.roundOff || 0;

    // Correct Total Savings Formula: MRP Differences + Item Level Discounts + Overall Cart Discount
    const totalSavedAmount = mrpSavings + actualItemDiscount + computedOfferDisc;
    
    let cashAmt = 0, upiAmt = 0, cardAmt = 0;
    let cashDetails = "-", upiDetails = "-", cardDetails = "-";
    
    // STRICT ADVANCE ISOLATION: Only read first payment array index for Advance receipts
    if (isAdvance && order.checkout?.paymentHistory?.length > 0) {
        const firstPayment = order.checkout.paymentHistory[0];
        const mode = (firstPayment.mode || "").toUpperCase();
        if (mode.includes("UPI") || mode.includes("GPAY") || mode.includes("PHONEPE")) { upiAmt = firstPayment.amount; upiDetails = firstPayment.details || "-"; }
        else if (mode.includes("CARD")) { cardAmt = firstPayment.amount; cardDetails = firstPayment.details || "-"; }
        else { cashAmt = firstPayment.amount; cashDetails = firstPayment.details || "-"; }
    } else {
        (order.checkout?.paymentHistory || []).forEach(p => {
            const mode = (p.mode || "").toUpperCase();
            if (mode.includes("UPI") || mode.includes("GPAY") || mode.includes("PHONEPE")) { upiAmt += p.amount; upiDetails = p.details || "-"; }
            else if (mode.includes("CARD")) { cardAmt += p.amount; cardDetails = p.details || "-"; }
            else { cashAmt += p.amount; cashDetails = p.details || "-"; }
        });
    }

    const initialAdvance = order.checkout?.advancePaid ?? 0;
    
    // DYNAMIC BALANCE: If Advance bill, strictly calculate (Total - Advance Amount). Otherwise, use final balance.
    const pendingBalance = isAdvance 
        ? (netAmount - initialAdvance) 
        : (order.financials?.balanceDue || 0);

    const hasPrescription = order.prescription && (
      order.prescription.sphRight || order.prescription.sphLeft || 
      order.prescription.clSphRight || order.prescription.clSphLeft
    );

    const htmlContent = `
    <!DOCTYPE html>
    <html>
    <head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>${titleText} - ${order.invoiceNo}</title>
    <style>
     * { box-sizing: border-box; font-family: 'Segoe UI', Roboto, Arial, sans-serif; font-weight: normal; color: #000; }
      @page { size: A4; margin: 10mm; } 
      body { margin: 0; background: #fff; font-size: 14px; padding: 20px; }
      .info-section { display: flex; justify-content: space-between; gap: 20px; margin-bottom: 5px; text-align: left; }
      
      /* Updated Header styling for 2 columns */
      .header { display: flex; align-items: center; justify-content: flex-start; border-bottom: 2px solid #16205f; padding-bottom: 15px; margin-bottom: 15px; }
      .logo { flex: 0 0 100px; margin-right: 20px; } 
      .logo img { width: 100px; height: 100px; object-fit: contain; }
      .header-content { flex: 1; text-align: left; }
      
      .clinic-name { font-size: 26px; font-weight: bold; color: #16205f; text-transform: uppercase; letter-spacing: 1px; margin-bottom: 4px; }
      .store-address { font-size: 13px; color: #000; font-weight: normal; margin-bottom: 4px; }
      .tagline { color: #000; font-weight: normal; font-size: 13px; margin-bottom: 4px; }
      

      .info-box { flex: 1; background: #f8fafc; border: 1px solid #000; border-radius: 8px; padding: 15px; text-align: left;margin-bottom: 10px; }
      .info-box h3 { margin: 0 0 12px 0; font-size: 15px; font-weight: bold; text-transform: uppercase; color: #000; border-bottom: 1px solid #000; padding-bottom: 16px; text-align: left; }
      .info-row { display: flex; justify-content: space-between; margin-bottom: 4px; font-size: 14px; text-align: left; }
      .info-row strong { font-weight: bold; }
      
      table.items { width: 100%; border-collapse: collapse; margin-bottom: 5px; }
      table.items th { background: #f1f5f9; color: #000; font-weight: bold; text-transform: uppercase; font-size: 13px; padding: 10px; text-align: left; border: 1px solid #000; }
      table.items td { padding: 10px; border: 1px solid #000; font-size: 14px; font-weight: normal; color: #000; }
      .text-center { text-align: center; } .text-right { text-align: right; }
      
      .financial-section { display: flex; gap: 20px; margin-bottom: 5px; align-items: flex-start; margin-top: 10px; }
      .payment-summary { flex: 1; background: #f8fafc; border: 1px solid #000; border-radius: 8px; padding: 15px;margin-bottom:10px; }
      .payment-summary h3 { margin: 0 0 12px 0; font-size: 15px; font-weight: bold; color: #000; border-bottom: 1px solid #000; padding-bottom: 6px; text-transform: uppercase; }
      .totals-summary { width: 340px; border: 1px solid #000; border-radius: 8px; padding: 5px; margin-bottom:10px}
      .summary-row { display: flex; justify-content: space-between; margin-bottom: 5px; font-size: 14px; font-weight: normal; }
      .summary-row.bold { font-weight: bold; color: #000; }
      .summary-row.net-total { font-size: 17px; font-weight: bold; color: #000; border-top: 1px dashed #000; padding-top: 12px; margin-top: 4px; }
      
      .rx-section { border: 1px solid #000; border-radius: 8px; padding: 5px; margin-bottom: 5px; text-align: left; }
      .rx-section h4 { margin: 0 0 12px 0; font-size: 15px; font-weight: bold; text-transform: uppercase; letter-spacing: 1px; }
      table.rx-table { width: 100%; border-collapse: collapse; font-size: 13px; text-align: center; }
      table.rx-table th, table.rx-table td { border: 1px solid #000; padding: 8px; text-align: center; font-weight: normal; }
      table.rx-table th { background: #f8fafc; color: #000; font-weight: bold; }
      
      .footer { display: flex; justify-content: space-between; align-items: flex-end; margin-top: 12px; font-size: 13px; font-weight: normal; color: #000; line-height: 1.2; }
      .sign-box { text-align: center; font-weight: bold; color: #000; border-top: 1px solid #000; padding-top: 18px; width: 220px; margin-top:17px; }
    </style>
    </head>
    <body>
      <div class="container">
        
       <div class="header">
        <div class="logo">
          <img src="${window.location.origin}/logo192.png" alt="Logo" />
        </div>

        <div class="header-content">
          <div class="clinic-name">Shruti Eye Care & Opticals</div>

          <div class="store-address">  ${activeStoreAdress}</br>
      Mobile No: 9470835831, 9939605949 | Landline: ${activeStoreNumber}
    </div>

          <div class="tagline">
                  Complete Eye Care • Computerized Eye Testing • Contact Lens • Premium Frames
          </div>
        </div>
      </div>

        <div class="info-section">
          <div class="info-box">
            <h3>Customer Details</h3>
            <div class="info-row"><span>Name:</span> <strong>${order.customer?.name?.toUpperCase() || 'WALK-IN'}</strong></div>
            <div class="info-row"><span>Mobile:</span> <strong>${order.customer?.phone || 'N/A'}</strong></div>
            <div class="info-row"><span>Address:</span> <strong>${order.customer?.address || 'India'}</strong></div>
          </div>
          <div class="info-box">
            <h3>${titleText}</h3>
            <div class="info-row"><span>Invoice No:</span> <strong>${order.invoiceNo}</strong></div>
            <div class="info-row"><span>Order Date:</span> <strong>${orderDateStr}</strong></div>
            <div class="info-row"><span>Delivery Date:</span> <strong>${deliveryDateStr}</strong></div>
          </div>
        </div>

        <table class="items">
          <thead>
            <tr>
              <th style="width: 8%;" class="text-center">S.No</th>
              <th>Product Description</th>
              <th class="text-center" style="width: 12%;">Qty</th>
              <th class="text-right" style="width: 20%;">Total Price</th>
            </tr>
          </thead>
          <tbody>
            ${(order.items || []).map((i, index) => {
              // 1. Safely extract and format strings (add spaces for separation)
              const pType = i.productType ? i.productType.toUpperCase() + " " : "";
              const pCode = i.productCode ? i.productCode.toUpperCase() + " " : "";
              const pName = i.productName ? i.productName.toUpperCase() : "";

              // 2. Check if the product is a lens
              const pNameLower = i.productName?.toLowerCase() || "";
              const pCodeLower = i.productCode?.toLowerCase() || "";
              const isLens = pNameLower.includes("lens") || pCodeLower.includes("lens") || i.productType === "Glass" || i.productType === "Lens" || i.productType === "Contact Lens";

              // 3. Apply the formatting rule: hide productCode if it's a lens
              const displayTitle = isLens 
                ? `${pType}${pName}`.trim() 
                : `${pType}${pCode}${pName}`.trim();

              // 4. Return the HTML row
              return `
              <tr>
                <td class="text-center" style="font-weight:normal;">${index + 1}</td>
                <td><strong style="font-weight:bold;">${displayTitle}</strong></td>
                <td class="text-center" style="font-weight:normal;">${i.quantity}</td>
                <td class="text-right" style="font-weight:normal;">Rs ${(i.retailPrice * i.quantity - (i.discount || 0)).toFixed(2)} <br><span style="font-size:10px;">-${Number(i.discount || 0).toFixed(2)} (${i.discountValue || 0})</span></td>
              </tr>
              `;
            }).join('')}
          </tbody>
        </table>

        ${order.customer?.company ? `
          <div style="margin-top: 10px; margin-bottom: 5px;">
            <h3 style="margin: 0 0 5px 0; font-size: 13px; font-weight: bold; text-transform: uppercase; color: #000; border-bottom: 1px solid #000; padding-bottom: 4px;">GST Breakup Details</h3>
            <table class="items" style="width: 100%; border-collapse: collapse; font-size: 12px;">
              <thead>
                <tr>
                  <th class="text-left">HSN CODE</th>
                  <th class="text-center">GST %</th>
                  <th class="text-right">SALE PRICE</th>
                  <th class="text-right">SGST 993869-1</th>
                  <th class="text-right">CGST 993869-1</th>
                  <th class="text-right">TOTAL GST</th>
                </tr>
              </thead>
              <tbody>
                ${order.items.map(i => {
                  const gstPct = Number(i.gstPercent) || 0;
                  const netPrice = (Number(i.retailPrice) * Number(i.quantity)) - Number(i.discount || 0);
                  const salePrice = netPrice / (1 + (gstPct / 100));
                  const totalGst = netPrice - salePrice;
                  const halfGst = totalGst / 2;
                  return `
                    <tr>
                      <td style="font-weight:normal;">${i.hsnCode || '-'}</td>
                      <td class="text-center" style="font-weight:normal;">${gstPct}%</td>
                      <td class="text-right" style="font-weight:normal;">Rs ${salePrice.toFixed(2)}</td>
                      <td class="text-right" style="font-weight:normal;">Rs ${halfGst.toFixed(2)}</td>
                      <td class="text-right" style="font-weight:normal;">Rs ${halfGst.toFixed(2)}</td>
                      <td class="text-right" style="font-weight:normal;">Rs ${totalGst.toFixed(2)}</td>
                    </tr>
                  `;
                }).join('')}
              </tbody>
            </table>
          </div>
        ` : ''}

        ${(hasPrescription && isAdvance) ? `
          <table class="rx-table" style="margin-top: 10px;">
            <tr>
              <th></th>
              <th colspan="5">✓ RIGHT EYE (OD)</th>
              <th colspan="5">✓ LEFT EYE (OS)</th>
            </tr>
            <tr>
              <th></th>
              <th>SPH</th><th>CYL</th><th>AXIS</th><th>PD</th><th>VA</th>
              <th>SPH</th><th>CYL</th><th>AXIS</th><th>PD</th><th>VA</th>
            </tr>
            <tr>
              <td><strong style="font-weight:bold;">DV</strong></td>
              <td>${order.prescription.sphRight || '-'}</td><td>${order.prescription.cylRight || '-'}</td><td>${order.prescription.axisRight || '-'}</td><td>${order.prescription.pdRight || '-'}</td><td>${order.prescription.vaRight || '-'}</td>
              <td>${order.prescription.sphLeft || '-'}</td><td>${order.prescription.cylLeft || '-'}</td><td>${order.prescription.axisLeft || '-'}</td><td>${order.prescription.pdLeft || '-'}</td><td>${order.prescription.vaLeft || '-'}</td>
            </tr>
            <tr>
              <td><strong style="font-weight:bold;">NV</strong></td>
              <td>${order.prescription.nvSphRight || '-'}</td><td>${order.prescription.nvCylRight || '-'}</td><td>${order.prescription.nvAxisRight || '-'}</td><td>-</td><td>-</td>
              <td>${order.prescription.nvSphLeft || '-'}</td><td>${order.prescription.nvCylLeft || '-'}</td><td>${order.prescription.nvAxisLeft || '-'}</td><td>-</td><td>-</td>
            </tr>
            <tr>
              <td><strong style="font-weight:bold;">ADD</strong></td>
              <td colspan="5" style="color:#b40000; font-weight:bold; font-size: 15px; text-align:left;">${order.prescription.addRight || '-'}</td>
              <td colspan="5" style="color:#b40000; font-weight:bold; font-size: 15px; text-align:left;">${order.prescription.addLeft || '-'}</td>
            </tr>
          </table>
        ` : ''}

        <div class="financial-section">
          <div class="payment-summary">
            <h3>Payment Logs Breakdown</h3>
            ${cashAmt > 0 ? `
              <div class="summary-row"><span>CASH Amount:</span> <strong style="font-weight:bold;">Rs ${cashAmt.toFixed(2)}</strong></div>
              ${cashDetails !== "-" ? `<div class="summary-row" style="color: #444; font-size: 12px; margin-top: -8px;"><span>Details: ${cashDetails}</span></div>` : ''}
            ` : ''}
            
            ${upiAmt > 0 ? `
              <div class="summary-row mt-2"><span>UPI Amount:</span> <strong style="font-weight:bold;">Rs ${upiAmt.toFixed(2)}</strong></div>
              ${upiDetails !== "-" ? `<div class="summary-row" style="color: #444; font-size: 12px; margin-top: -8px;"><span>Details: ${upiDetails}</span></div>` : ''}
            ` : ''}
            
            ${cardAmt > 0 ? `
              <div class="summary-row mt-2"><span>CARD Amount:</span> <strong style="font-weight:bold;">Rs ${cardAmt.toFixed(2)}</strong></div>
              ${cardDetails !== "-" ? `<div class="summary-row" style="color: #444; font-size: 12px; margin-top: -8px;"><span>Details: ${cardDetails}</span></div>` : ''}
            ` : ''}

            <div class="summary-row bold" style="margin-top: 15px; padding-top: 15px; border-top: 1px dashed #000;">
              <span>Payment Date:</span> <span>${paymentDateStr}</span>
            </div>
            <div class="summary-row bold" style="color: ${pendingBalance > 0 ? '#e11d48' : '#059669'}; font-size:15px;">
              <span>Balance Left To Pay:</span> <span>Rs ${pendingBalance.toFixed(2)}</span>
            </div>
          </div>

          <div class="totals-summary">
            <div class="summary-row"><span>Gross Total:</span> <strong style="font-weight:bold;">Rs ${grossTotal.toFixed(2)}</strong></div>
            
            ${actualItemDiscount > 0 ? `<div class="summary-row" style="color: #b40000;"><span>Item Discount:</span> <strong style="font-weight:bold;">- Rs ${actualItemDiscount.toFixed(2)}</strong></div>` : ''}
            
            ${computedOfferDisc > 0 ? `
              <div class="summary-row" style="color: #b40000;">
                <span>${isPercent ? `${offerDiscountVal}% Disc` : 'Overall Disc'}:</span> 
                <strong style="font-weight:bold;">- Rs ${computedOfferDisc.toFixed(2)}</strong>
              </div>
            ` : ''}
            
            <div class="summary-row"><span>Round Off (+/-):</span> <strong style="font-weight:bold;">${roundOffVal < 0 ? `- Rs ${Math.abs(roundOffVal).toFixed(2)}` : `+ Rs ${Number(roundOffVal).toFixed(2)}`}</strong></div>
            
            <div class="summary-row net-total"><span>Payable Amount:</span> <span>Rs ${netAmount.toFixed(2)}</span></div>
            
            ${totalSavedAmount > 0 ? `
            <div class="summary-row" style="background: #000; color: #fff; padding: 10px 14px; border-radius: 6px; margin-top: 15px; font-weight: bold; font-size: 15px;">
              <span style="color:#fff;">TOTAL YOU SAVED:</span> <span style="color:#fff;">Rs ${totalSavedAmount.toFixed(2)}</span>
            </div>
            ` : ''}
            
            <div class="summary-row bold" style="margin-top: 15px; color: #000; font-size:15px;">
              <span>Advance Amount:</span> <span>Rs ${initialAdvance.toFixed(2)}</span>
            </div>
          </div>
        </div>

        <div class="footer">
          <div>
            <strong style="font-weight:bold;">Terms & Conditions</strong><br>
            1. Goods once sold cannot be taken back.<br>
            2. Guaranteed goods are subject to manufacturer terms.<br>
            3. Subject to Patna jurisdiction.
          </div>
          <div class="sign-box">AUTHORISED SIGNATORY</div>
        </div>

      </div>
      <script>
        window.addEventListener('load', function() {
          setTimeout(function() {
            window.print();
            setTimeout(function() { window.close(); }, 500);
          }, 300);
        });
      </script>
    </body>
    </html>
    `;

    printWindow.document.write(htmlContent);
    printWindow.document.close();
  };
  return (
    <div className="flex min-h-screen bg-slate-50 text-slate-800 font-sans antialiased selection:bg-blue-200 text-base">
      <StoreSidebar />

      {/* CONTACT MODAL POPUP (SMS & WHATSAPP) */}
      <AnimatePresence>
        {showContactModal && contactOrder && (
          <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
            <motion.div initial={{ scale: 0.95, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} exit={{ scale: 0.95, opacity: 0 }} className="w-full max-w-sm bg-white border border-slate-200 rounded-3xl p-6 shadow-2xl">
              <h3 className="text-lg font-black text-slate-800 border-b border-slate-100 pb-3 mb-4 flex items-center gap-2">
                {contactMethod === 'whatsapp' ? (
                  <><MessageCircle className="text-green-500" /> Send via WhatsApp</>
                ) : (
                  <><MessageSquare className="text-blue-500" /> Send via SMS</>
                )}
              </h3>
              
              <div className="space-y-4">
                <div className="text-sm font-medium text-slate-600">
                  Customer: <strong>{contactOrder.customer?.name || "Walk-In"}</strong><br/>
                  Phone: <strong>{contactOrder.customer?.phone || "N/A"}</strong>
                </div>

                <div className="bg-slate-50 p-4 rounded-xl border border-slate-200 text-xs text-slate-700 italic font-medium whitespace-pre-wrap">
                  Select the type of notification you want to send.
                </div>

                <div className="flex flex-col gap-3 mt-4">
                  <button 
                    onClick={() => contactMethod === 'whatsapp' ? handleSendWhatsapp(contactOrder, 'advance') : handleSendSMS(contactOrder, 'advance')} 
                    className={`w-full py-3 text-white font-black uppercase rounded-xl shadow-lg transition ${contactMethod === 'whatsapp' ? 'bg-green-600 hover:bg-green-500' : 'bg-blue-600 hover:bg-blue-500'}`}
                  >
                    1. Advance Receipt
                  </button>
                  
                  <button 
                    onClick={() => contactMethod === 'whatsapp' ? handleSendWhatsapp(contactOrder, 'ready') : handleSendSMS(contactOrder, 'ready')} 
                    className={`w-full py-3 text-white font-black uppercase rounded-xl shadow-lg transition ${contactMethod === 'whatsapp' ? 'bg-green-600 hover:bg-green-500' : 'bg-blue-600 hover:bg-blue-500'}`}
                  >
                    2. Your Order is Ready
                  </button>

                  {/* Only show Final Invoice option if balance is 0 */}
                  {contactOrder.financials?.balanceDue <= 0 && (
                    <button 
                      onClick={() => contactMethod === 'whatsapp' ? handleSendWhatsapp(contactOrder, 'final') : handleSendSMS(contactOrder, 'final')} 
                      className={`w-full py-3 text-white font-black uppercase rounded-xl shadow-lg transition ${contactMethod === 'whatsapp' ? 'bg-green-600 hover:bg-green-500' : 'bg-blue-600 hover:bg-blue-500'}`}
                    >
                      3. Final Receipt
                    </button>
                  )}
                  
                  <button onClick={() => { setShowContactModal(false); setContactOrder(null); }} className="w-full py-3 bg-slate-100 hover:bg-slate-200 text-slate-700 font-bold rounded-xl transition">
                    Cancel
                  </button>
                </div>
              </div>
            </motion.div>
          </div>
        )}
      </AnimatePresence>

      {/* NEW: DYNAMIC PRODUCT CATEGORY QUICK ADD POPUP */}
      <AnimatePresence>
        {showProductTypePopup && (
           <motion.div initial={{opacity:0}} animate={{opacity:1}} exit={{opacity:0}} className="fixed inset-0 z-[99999] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
             <motion.div initial={{scale:0.95}} animate={{scale:1}} exit={{scale:0.95}} className="bg-white rounded-3xl shadow-2xl w-full max-w-2xl overflow-hidden flex flex-col max-h-[85vh]">
               
               {/* Header */}
               <div className="p-4 border-b border-slate-100 flex justify-between items-center bg-slate-50">
                 <h3 className="text-lg font-black uppercase text-slate-800 flex items-center gap-2">
                    <Plus size={20} className="text-blue-600" /> {quickAddForm ? `Configure ${selectedProductType}` : `Select ${selectedProductType}`}
                 </h3>
                 <button onClick={() => { setShowProductTypePopup(false); setQuickAddForm(null); }} className="p-2 bg-slate-200 text-slate-600 rounded-xl hover:bg-rose-100 hover:text-rose-600 transition"><X size={18}/></button>
               </div>

               {quickAddForm ? (
                 /* QUICK ADD FORM VIEW */
                 <div className="p-6 space-y-4 overflow-y-auto">
                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <label className="text-[10px] font-black uppercase text-slate-400 block mb-1">Product Code</label>
                        <input type="text" value={quickAddForm.product.productCode} readOnly className="w-full p-2.5 bg-slate-100 border border-slate-200 rounded-xl text-xs font-mono font-bold text-slate-600" />
                      </div>
                      <div>
                        <label className="text-[10px] font-black uppercase text-slate-400 block mb-1">Name / Brand</label>
                        <input type="text" value={quickAddForm.product.productName} readOnly className="w-full p-2.5 bg-slate-100 border border-slate-200 rounded-xl text-xs font-bold text-slate-600" />
                      </div>
                    </div>

                    <div className="grid grid-cols-3 gap-4">
                      <div>
                        <label className="text-[10px] font-black uppercase text-slate-400 block mb-1">Retail Price</label>
                        <input 
                          type="number" 
                          value={quickAddForm.retailPrice} 
                          onChange={e => setQuickAddForm({...quickAddForm, retailPrice: e.target.value})} 
                          className="w-full p-2.5 bg-white border border-blue-300 rounded-xl text-xs font-mono font-bold text-blue-700 outline-none focus:ring-2 focus:ring-blue-100" 
                        />
                      </div>
                      <div>
                        <label className="text-[10px] font-black uppercase text-slate-400 block mb-1">GST %</label>
                        <input 
                          type="number" 
                          value={quickAddForm.gstPercent} 
                          onChange={e => setQuickAddForm({...quickAddForm, gstPercent: e.target.value})} 
                          className="w-full p-2.5 bg-white border border-slate-300 rounded-xl text-xs font-mono font-bold outline-none focus:border-blue-500" 
                        />
                      </div>
                      <div>
                        <label className="text-[10px] font-black uppercase text-slate-400 block mb-1">HSN Code</label>
                        <input 
                          type="text" 
                          value={quickAddForm.hsnCode || ''} 
                          onChange={e => setQuickAddForm({...quickAddForm, hsnCode: e.target.value})} 
                          className="w-full p-2.5 bg-white border border-slate-300 rounded-xl text-xs font-mono font-bold outline-none focus:border-blue-500" 
                        />
                      </div>
                    </div>

                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <label className="text-[10px] font-black uppercase text-slate-400 block mb-1">Discount Mode</label>
                        <select 
                          value={quickAddForm.discountType}
                          onChange={e => setQuickAddForm({...quickAddForm, discountType: e.target.value})}
                          className="w-full p-2.5 bg-white border border-slate-300 rounded-xl text-xs font-bold outline-none cursor-pointer focus:border-purple-500"
                        >
                          <option value="amount">Value (₹)</option>
                          <option value="percent">Percentage (%)</option>
                        </select>
                      </div>
                      <div>
                        <label className="text-[10px] font-black uppercase text-slate-400 block mb-1">Discount Value</label>
                        <input 
                          type="number" 
                          value={quickAddForm.discountValue} 
                          onChange={e => setQuickAddForm({...quickAddForm, discountValue: e.target.value})} 
                          className="w-full p-2.5 bg-white border border-purple-300 rounded-xl text-xs font-mono font-bold text-purple-700 outline-none focus:ring-2 focus:ring-purple-100" 
                        />
                      </div>
                    </div>

                    <div className="bg-slate-50 p-4 rounded-xl border border-slate-200 mt-4 space-y-2">
                       {(() => {
                          let price = Number(quickAddForm.retailPrice) || 0;
                          let discVal = Number(quickAddForm.discountValue) || 0;
                          let discAmount = quickAddForm.discountType === 'percent' ? price * (discVal / 100) : discVal;
                          let totalSales = price - discAmount;
                          let gstPct = Number(quickAddForm.gstPercent) || 0;
                          let basicPrice = totalSales / (1 + (gstPct / 100));
                          let gstAmt = totalSales - basicPrice;
                          
                          return (
                            <>
                              <div className="flex justify-between text-xs font-medium text-slate-600">
                                <span>Basic Price (Excl. GST)</span>
                                <span>₹{basicPrice.toFixed(2)}</span>
                              </div>
                              <div className="flex justify-between text-xs font-medium text-slate-600">
                                <span>GST Amount ({gstPct}%)</span>
                                <span>₹{gstAmt.toFixed(2)}</span>
                              </div>
                              <div className="flex justify-between text-sm font-black text-slate-900 border-t border-slate-200 pt-2 mt-2">
                                <span>Total Sales (Rs)</span>
                                <span className="text-emerald-600">₹{totalSales.toFixed(2)}</span>
                              </div>
                            </>
                          )
                       })()}
                    </div>

                    <div className="flex gap-3 pt-2">
                      <button onClick={() => setQuickAddForm(null)} className="flex-1 py-3 bg-slate-100 text-slate-700 font-bold rounded-xl hover:bg-slate-200 transition">Back</button>
                      <button onClick={() => {
                          let price = Number(quickAddForm.retailPrice) || 0;
                          let discVal = Number(quickAddForm.discountValue) || 0;
                          let discAmount = quickAddForm.discountType === 'percent' ? price * (discVal / 100) : discVal;
                          
                          addToCartAction(quickAddForm.product, {
                             retailPrice: price,
                             discountAmount: discAmount,
                             discountType: quickAddForm.discountType,
                             discountValue: discVal,
                             gstPercent: Number(quickAddForm.gstPercent) || 0,
                             hsnCode: quickAddForm.hsnCode || ''
                          });
                          setShowProductTypePopup(false);
                          setQuickAddForm(null);
                      }} className="flex-1 py-3 bg-blue-600 text-white font-black uppercase rounded-xl hover:bg-blue-500 transition shadow-lg">Confirm & Add</button>
                    </div>
                 </div>
               ) : (
                 /* LIST VIEW */
                 <>
                   <div className="p-4 border-b border-slate-100">
                     <div className="relative flex items-center">
                        <Search size={18} className="absolute left-4 text-slate-400"/>
                        <input type="text" placeholder={`Search available ${selectedProductType}s...`} value={productTypeSearchQuery} onChange={e => setProductTypeSearchQuery(e.target.value)} className="w-full pl-11 pr-4 py-3 bg-slate-100 border-none rounded-xl outline-none font-bold text-slate-700 focus:ring-2 focus:ring-blue-500 transition-shadow"/>
                     </div>
                   </div>
                   <div className="overflow-y-auto p-4 flex-1">
                     {(() => {
                        const filteredList = products.filter(p => (p.productType || "Other").toLowerCase().includes(selectedProductType.toLowerCase()) && (p.productName?.toLowerCase().includes(productTypeSearchQuery.toLowerCase()) || p.productCode?.toLowerCase().includes(productTypeSearchQuery.toLowerCase())));
                        
                        if(filteredList.length === 0) {
                            return <div className="text-center p-8 text-slate-400 font-medium">No {selectedProductType}s found matching your search.</div>;
                        }

                        return filteredList.map(prod => (
                        <div key={prod.id} className="flex justify-between items-center p-3 border border-slate-100 rounded-xl mb-2 hover:border-blue-300 hover:bg-blue-50 transition group cursor-pointer" onClick={() => {
                            setQuickAddForm({
                              product: prod,
                              retailPrice: prod.retailPrice || prod.mrp || 0,
                              discountType: 'amount',
                              discountValue: 0,
                              gstPercent: 0,
                              hsnCode: ''
                            });
                        }}>
                           <div>
                              <div className="font-bold text-slate-800 group-hover:text-blue-700">{prod.productName}</div>
                              <div className="text-xs text-slate-400 font-mono mt-0.5">SKU: {prod.productCode} | Stock: {prod.quantity}</div>
                           </div>
                           <div className="flex items-center gap-4">
                              <div className="font-black text-blue-600">₹{Number(prod.retailPrice).toLocaleString()}</div>
                              <button className="px-4 py-2 bg-slate-900 text-white text-xs font-bold rounded-lg hover:bg-blue-600 transition uppercase tracking-wider shadow-sm">Select</button>
                           </div>
                        </div>
                        ));
                     })()}
                   </div>
                 </>
               )}
             </motion.div>
           </motion.div>
        )}
      </AnimatePresence>

      {/* COMPLETION MODAL */}
      <AnimatePresence>
        {completingOrder && (
          <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
            <motion.div initial={{ scale: 0.95, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} exit={{ scale: 0.95, opacity: 0 }} className="w-full max-w-sm bg-white border border-slate-200 rounded-3xl p-6 shadow-2xl">
              <h3 className="text-lg font-black text-slate-800 border-b border-slate-100 pb-3 mb-4">Complete Order Balance</h3>
              
              <div className="space-y-4">
                <div className="flex items-center justify-between bg-slate-50 p-3 rounded-xl border border-slate-100">
                  <span className="text-sm font-bold text-slate-500">Remaining Base Due</span>
                  <span className="text-lg font-black text-slate-800 font-mono">₹{completingOrder.financials.balanceDue.toLocaleString()}</span>
                </div>
                
                <div>
                  <label className="text-xs font-bold text-slate-500 uppercase tracking-wider block mb-1.5">Apply Round Off (+/-)</label>
                  <input type="number" placeholder="0" value={completionRoundOff} onChange={(e) => setCompletionRoundOff(e.target.value)} className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl outline-none font-mono font-bold text-slate-800 focus:bg-white focus:border-blue-500" />
                </div>

                <div className="bg-emerald-50 p-4 rounded-xl border border-emerald-100 text-center">
                  <span className="text-xs font-bold text-emerald-600 uppercase tracking-wider block mb-1">Final Collection Amount</span>
                  <span className="text-3xl font-black text-emerald-700 font-mono">
                    ₹{Math.max(0, completingOrder.financials.balanceDue - (Number(completionRoundOff) || 0)).toLocaleString()}
                  </span>
                </div>

                <div className="grid grid-cols-2 gap-3">
                  <div>
                    <label className="text-xs font-bold text-slate-500 uppercase tracking-wider block mb-1.5">Payment Mode</label>
                    <select value={completionPaymentMode} onChange={e => {setCompletionPaymentMode(e.target.value); setCompletionPaymentDetails("");}} className="w-full p-3 border border-slate-300 rounded-xl outline-none font-bold text-slate-800 focus:border-blue-500">
                      <option>CASH</option><option>UPI / GPay</option><option>Credit Card</option><option>Bank Transfer</option>
                    </select>
                  </div>
                  <div>
                    <label className="text-xs font-bold text-slate-500 uppercase tracking-wider block mb-1.5">Details (Trxn No)</label>
                    <input type="text" placeholder={completionPaymentMode === "CASH" ? "N/A" : "Txn / Ref No"} disabled={completionPaymentMode === "CASH"} value={completionPaymentDetails} onChange={(e) => setCompletionPaymentDetails(e.target.value)} className="w-full p-3 border border-slate-300 rounded-xl outline-none font-mono text-xs font-bold text-slate-800 focus:border-blue-500 disabled:bg-slate-100 disabled:text-slate-400" />
                  </div>
                </div>
              </div>
              <div className="flex gap-3 mt-6">
                <button onClick={() => setCompletingOrder(null)} className="w-1/2 py-3 bg-slate-100 hover:bg-slate-200 text-slate-700 font-bold rounded-xl transition">Cancel</button>
                <button onClick={handleFinalizePendingOrder} className="w-1/2 py-3 bg-emerald-600 hover:bg-emerald-500 text-white font-black uppercase rounded-xl shadow-lg transition">Confirm Pay</button>
              </div>
            </motion.div>
          </div>
        )}
      </AnimatePresence>

      {/* RE-ARCHITECTED INTERACTIVE DYNAMIC MULTI-TAB PRESCRIPTION MODAL ENGINE */}
      <AnimatePresence>
        {showPrescriptionModal && (
          <motion.div 
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} 
            className="fixed inset-0 z-[9999] bg-black/70 backdrop-blur-md flex items-center justify-center p-4"
          >
            <motion.div 
              initial={{ scale: 0.95, opacity: 0, y: 10 }} animate={{ scale: 1, opacity: 1, y: 0 }} exit={{ scale: 0.95, opacity: 0, y: 10 }}
              className="bg-white border border-slate-200 rounded-3xl p-8 shadow-2xl w-full max-w-5xl relative max-h-[95vh] overflow-y-auto"
            >
              <button onClick={() => setShowPrescriptionModal(false)} className="absolute top-6 right-6 text-slate-400 hover:text-rose-500 transition-colors bg-slate-100 hover:bg-slate-200 p-2 rounded-xl">
                <X size={20} />
              </button>

              <h2 className="text-2xl font-black uppercase tracking-wider text-slate-800 flex items-center gap-3 border-b border-slate-100 pb-4 mb-6">
                <QrCode size={26} className="text-purple-600" /> Dynamic Prescription Matrix Configurator
              </h2>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8 bg-slate-50 p-6 rounded-2xl border border-slate-100">
                {/* Patient Profile Box */}
                <div className="space-y-4">
                  <div className="flex items-center justify-between">
                    <h3 className="text-sm font-black uppercase text-blue-600 flex items-center gap-2"><UserPlus size={16}/> Patient Directory Link</h3>
                    <select value={selectedPrescriptionId} onChange={(e) => handleSelectPrescription(e.target.value)} className="p-1.5 text-xs border border-slate-300 rounded-lg text-slate-700 outline-none w-48 max-w-full">
                      <option value="">-- Start Fresh / Select History --</option>
                      {savedPrescriptions.map(p => (
                        <option key={p.id} value={p.id}>{p.patient?.name || p.name} ({p.patient?.mobile || p.phone})</option>
                      ))}
                    </select>
                  </div>
                  <div className="grid grid-cols-2 gap-3">
                    <div><label className="text-[10px] uppercase font-bold text-slate-500 block mb-1">Patient Name</label><input type="text" value={patientName} onChange={e => setPatientName(e.target.value)} className="w-full p-2.5 bg-white border border-slate-300 rounded-xl outline-none text-slate-800 focus:border-purple-500" /></div>
                    <div><label className="text-[10px] uppercase font-bold text-slate-500 block mb-1">Mobile No</label><input type="tel" value={patientMobile} onChange={e => setPatientMobile(e.target.value)} className="w-full p-2.5 bg-white border border-slate-300 rounded-xl outline-none text-slate-800 focus:border-purple-500 font-mono" /></div>
                    <div><label className="text-[10px] uppercase font-bold text-slate-500 block mb-1">Email Addr</label><input type="email" value={patientEmail} onChange={e => setPatientEmail(e.target.value)} className="w-full p-2.5 bg-white border border-slate-300 rounded-xl outline-none text-slate-800 focus:border-purple-500" /></div>
                    <div><label className="text-[10px] uppercase font-bold text-slate-500 block mb-1">Date of Birth</label><input type="date" value={patientDob} onChange={e => setPatientDob(e.target.value)} className="w-full p-2.5 bg-white border border-slate-300 rounded-xl outline-none text-slate-800 focus:border-purple-500 font-mono" /></div>
                    <div><label className="text-[10px] uppercase font-bold text-slate-500 block mb-1">Age Check</label><input type="number" placeholder="Years" value={patientAge} onChange={e => setPatientAge(e.target.value)} className="w-full p-2.5 bg-white border border-slate-300 rounded-xl outline-none text-slate-800 focus:border-purple-500 font-mono" /></div>
                    <div><label className="text-[10px] uppercase font-bold text-slate-500 block mb-1">Gender</label><select value={patientGender} onChange={e => setPatientGender(e.target.value)} className="w-full p-2.5 bg-white border border-slate-300 rounded-xl outline-none text-slate-800 focus:border-purple-500 cursor-pointer"><option>Male</option><option>Female</option><option>Other</option></select></div>
                  </div>
                </div>

                {/* Doctor Profile Box */}
                <div className="space-y-4">
                  <h3 className="text-sm font-black uppercase text-emerald-600 flex items-center gap-2"><Stethoscope size={16}/> Referring Optometrist / Doctor</h3>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    <div className="sm:col-span-2"><label className="text-[10px] uppercase font-bold text-slate-500 block mb-1">Doctor Name *</label><input type="text" placeholder="Mandatory for printing" value={doctorName} onChange={e => setDoctorName(e.target.value)} className="w-full p-2.5 bg-white border border-slate-300 rounded-xl outline-none text-slate-800 focus:border-emerald-500" /></div>
                    <div><label className="text-[10px] uppercase font-bold text-slate-500 block mb-1">Mobile No</label><input type="tel" value={doctorMobile} onChange={e => setDoctorMobile(e.target.value)} className="w-full p-2.5 bg-white border border-slate-300 rounded-xl outline-none text-slate-800 focus:border-emerald-500 font-mono" /></div>
                    <div><label className="text-[10px] uppercase font-bold text-slate-500 block mb-1">Clinic Address</label><input type="text" value={doctorAddress} onChange={e => setDoctorAddress(e.target.value)} className="w-full p-2.5 bg-white border border-slate-300 rounded-xl outline-none text-slate-800 focus:border-emerald-500" /></div>
                  </div>
                </div>
              </div>

              <div className="flex gap-3 border-b border-slate-200 pb-4 mb-6 text-sm font-bold">
                <button type="button" onClick={() => setPrescriptionTab("eyewear")} className={`px-6 py-2.5 rounded-xl transition-all ${prescriptionTab === "eyewear" ? "bg-purple-600 text-white shadow-lg shadow-purple-200" : "bg-slate-50 text-slate-600 border border-slate-200 hover:text-purple-700"}`}>Eyewear Rx</button>
                <button type="button" onClick={() => setPrescriptionTab("contactLens")} className={`px-6 py-2.5 rounded-xl transition-all ${prescriptionTab === "contactLens" ? "bg-purple-600 text-white shadow-lg shadow-purple-200" : "bg-slate-50 text-slate-600 border border-slate-200 hover:text-purple-700"}`}>Contact Lens Rx</button>
                <button type="button" onClick={() => setPrescriptionTab("transpose")} className={`px-6 py-2.5 rounded-xl transition-all ${prescriptionTab === "transpose" ? "bg-purple-600 text-white shadow-lg shadow-purple-200" : "bg-slate-50 text-slate-600 border border-slate-200 hover:text-purple-700"}`}>Transpose Rx</button>
              </div>
              
              {/* TAB 1: EYEWEAR PROTOCOL RULES GRID */}
              {prescriptionTab === "eyewear" && (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                  <div className="space-y-5 bg-white p-6 rounded-2xl border border-slate-200 shadow-sm">
                    <span className="text-sm font-black uppercase tracking-widest block text-purple-600 border-b border-slate-100 pb-3 mb-4 flex items-center gap-2"><Eye size={18}/> RIGHT EYE (OD)</span>
                    
                    <div><span className="text-[10px] uppercase font-bold text-slate-500 block mb-2">Distance Vision (DV)</span>
                    <div className="grid grid-cols-3 gap-4">
                      <div><label className="text-[10px] text-slate-400 block mb-1">R-SPH</label><input type="text" placeholder="0.00" value={sphRight} onChange={e => setSphRight(e.target.value)} className="w-full p-2.5 bg-slate-50 border border-slate-300 rounded-xl text-center font-mono text-slate-800 outline-none focus:border-purple-500 focus:bg-white" /></div>
                      <div><label className="text-[10px] text-slate-400 block mb-1">R-CYL</label><input type="text" placeholder="0.00" value={cylRight} onChange={e => setCylRight(e.target.value)} className="w-full p-2.5 bg-slate-50 border border-slate-300 rounded-xl text-center font-mono text-slate-800 outline-none focus:border-purple-500 focus:bg-white" /></div>
                      <div><label className="text-[10px] text-slate-400 block mb-1">R-AXIS</label><input type="text" placeholder="0" value={axisRight} onChange={e => setAxisRight(e.target.value)} className="w-full p-2.5 bg-slate-50 border border-slate-300 rounded-xl text-center font-mono text-slate-800 outline-none focus:border-purple-500 focus:bg-white" /></div>
                    </div></div>

                    <div className="pt-3 border-t border-slate-100"><span className="text-[10px] uppercase font-bold text-slate-500 block mb-2">Near Vision (NV)</span>
                    <div className="grid grid-cols-3 gap-4">
                      <div><label className="text-[10px] text-slate-400 block mb-1">R-SPH</label><input type="text" placeholder="0.00" value={nvSphRight} onChange={e => setNvSphRight(e.target.value)} className="w-full p-2.5 bg-slate-50 border border-slate-300 rounded-xl text-center font-mono text-slate-800 outline-none focus:border-purple-500 focus:bg-white" /></div>
                      <div><label className="text-[10px] text-slate-400 block mb-1">R-CYL</label><input type="text" placeholder="0.00" value={nvCylRight} onChange={e => setNvCylRight(e.target.value)} className="w-full p-2.5 bg-slate-50 border border-slate-300 rounded-xl text-center font-mono text-slate-800 outline-none focus:border-purple-500 focus:bg-white" /></div>
                      <div><label className="text-[10px] text-slate-400 block mb-1">R-AXIS</label><input type="text" placeholder="0" value={nvAxisRight} onChange={e => setNvAxisRight(e.target.value)} className="w-full p-2.5 bg-slate-50 border border-slate-300 rounded-xl text-center font-mono text-slate-800 outline-none focus:border-purple-500 focus:bg-white" /></div>
                    </div></div>

                    <div className="pt-3 border-t border-slate-100"><span className="text-[10px] uppercase font-bold text-slate-500 block mb-2">Additional Parameters</span>
                    <div className="grid grid-cols-3 gap-4">
                      <div><label className="text-[10px] text-slate-400 block mb-1">R-ADD</label><input type="text" placeholder="Add" value={addRight} onChange={e => setAddRight(e.target.value)} className="w-full p-2.5 bg-slate-50 border border-slate-300 rounded-xl text-center font-mono text-slate-800 outline-none focus:border-purple-500 focus:bg-white" /></div>
                      <div><label className="text-[10px] text-slate-400 block mb-1">R-PD</label><input type="text" placeholder="Distance" value={pdRight} onChange={e => setPdRight(e.target.value)} className="w-full p-2.5 bg-slate-50 border border-slate-300 rounded-xl text-center font-mono text-slate-800 outline-none focus:border-purple-500 focus:bg-white" /></div>
                      <div><label className="text-[10px] text-slate-400 block mb-1">R-VA</label><input type="text" placeholder="Vision" value={vaRight} onChange={e => setVaRight(e.target.value)} className="w-full p-2.5 bg-slate-50 border border-slate-300 rounded-xl text-center font-mono text-slate-800 outline-none focus:border-purple-500 focus:bg-white" /></div>
                    </div></div>
                  </div>
                  
                  <div className="space-y-5 bg-white p-6 rounded-2xl border border-slate-200 shadow-sm">
                    <span className="text-sm font-black uppercase tracking-widest block text-purple-600 border-b border-slate-100 pb-3 mb-4 flex items-center gap-2"><Eye size={18}/> LEFT EYE (OS)</span>
                    
                    <div><span className="text-[10px] uppercase font-bold text-slate-500 block mb-2">Distance Vision (DV)</span>
                    <div className="grid grid-cols-3 gap-4">
                      <div><label className="text-[10px] text-slate-400 block mb-1">L-SPH</label><input type="text" placeholder="0.00" value={sphLeft} onChange={e => setSphLeft(e.target.value)} className="w-full p-2.5 bg-slate-50 border border-slate-300 rounded-xl text-center font-mono text-slate-800 outline-none focus:border-purple-500 focus:bg-white" /></div>
                      <div><label className="text-[10px] text-slate-400 block mb-1">L-CYL</label><input type="text" placeholder="0.00" value={cylLeft} onChange={e => setCylLeft(e.target.value)} className="w-full p-2.5 bg-slate-50 border border-slate-300 rounded-xl text-center font-mono text-slate-800 outline-none focus:border-purple-500 focus:bg-white" /></div>
                      <div><label className="text-[10px] text-slate-400 block mb-1">L-AXIS</label><input type="text" placeholder="0" value={axisLeft} onChange={e => setAxisLeft(e.target.value)} className="w-full p-2.5 bg-slate-50 border border-slate-300 rounded-xl text-center font-mono text-slate-800 outline-none focus:border-purple-500 focus:bg-white" /></div>
                    </div></div>

                    <div className="pt-3 border-t border-slate-100"><span className="text-[10px] uppercase font-bold text-slate-500 block mb-2">Near Vision (NV)</span>
                    <div className="grid grid-cols-3 gap-4">
                      <div><label className="text-[10px] text-slate-400 block mb-1">L-SPH</label><input type="text" placeholder="0.00" value={nvSphLeft} onChange={e => setNvSphLeft(e.target.value)} className="w-full p-2.5 bg-slate-50 border border-slate-300 rounded-xl text-center font-mono text-slate-800 outline-none focus:border-purple-500 focus:bg-white" /></div>
                      <div><label className="text-[10px] text-slate-400 block mb-1">L-CYL</label><input type="text" placeholder="0.00" value={nvCylLeft} onChange={e => setNvCylLeft(e.target.value)} className="w-full p-2.5 bg-slate-50 border border-slate-300 rounded-xl text-center font-mono text-slate-800 outline-none focus:border-purple-500 focus:bg-white" /></div>
                      <div><label className="text-[10px] text-slate-400 block mb-1">L-AXIS</label><input type="text" placeholder="0" value={nvAxisLeft} onChange={e => setNvAxisLeft(e.target.value)} className="w-full p-2.5 bg-slate-50 border border-slate-300 rounded-xl text-center font-mono text-slate-800 outline-none focus:border-purple-500 focus:bg-white" /></div>
                    </div></div>

                    <div className="pt-3 border-t border-slate-100"><span className="text-[10px] uppercase font-bold text-slate-500 block mb-2">Additional Parameters</span>
                    <div className="grid grid-cols-3 gap-4">
                      <div><label className="text-[10px] text-slate-400 block mb-1">L-ADD</label><input type="text" placeholder="Add" value={addLeft} onChange={e => setAddLeft(e.target.value)} className="w-full p-2.5 bg-slate-50 border border-slate-300 rounded-xl text-center font-mono text-slate-800 outline-none focus:border-purple-500 focus:bg-white" /></div>
                      <div><label className="text-[10px] text-slate-400 block mb-1">L-PD</label><input type="text" placeholder="Distance" value={pdLeft} onChange={e => setPdLeft(e.target.value)} className="w-full p-2.5 bg-slate-50 border border-slate-300 rounded-xl text-center font-mono text-slate-800 outline-none focus:border-purple-500 focus:bg-white" /></div>
                      <div><label className="text-[10px] text-slate-400 block mb-1">L-VA</label><input type="text" placeholder="Vision" value={vaLeft} onChange={e => setVaLeft(e.target.value)} className="w-full p-2.5 bg-slate-50 border border-slate-300 rounded-xl text-center font-mono text-slate-800 outline-none focus:border-purple-500 focus:bg-white" /></div>
                    </div></div>
                  </div>
                </div>
              )}

              {/* TAB 2: CONTACT LENS PROTOCOL RULES GRID */}
              {prescriptionTab === "contactLens" && (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                  <div className="space-y-5 bg-white p-6 rounded-2xl border border-slate-200 shadow-sm"><span className="text-sm font-black uppercase tracking-widest block text-blue-600 border-b border-slate-100 pb-3 mb-4">RIGHT CONTACT LENS</span>
                    <div><span className="text-[10px] uppercase font-bold text-slate-500 block mb-2">Distance Vision (DV)</span>
                    <div className="grid grid-cols-3 gap-4">
                      <div><label className="text-[10px] text-slate-400 block mb-1">R-SPH</label><input type="text" placeholder="0.00" value={clSphRight} onChange={e => setClSphRight(e.target.value)} className="w-full p-2.5 bg-slate-50 border border-slate-300 rounded-xl text-center font-mono text-slate-800 outline-none focus:border-blue-500" /></div>
                      <div><label className="text-[10px] text-slate-400 block mb-1">R-CYL</label><input type="text" placeholder="0.00" value={clCylRight} onChange={e => setCylRight(e.target.value)} className="w-full p-2.5 bg-slate-50 border border-slate-300 rounded-xl text-center font-mono text-slate-800 outline-none focus:border-blue-500" /></div>
                      <div><label className="text-[10px] text-slate-400 block mb-1">R-AXIS</label><input type="text" placeholder="0" value={clAxisRight} onChange={e => setAxisRight(e.target.value)} className="w-full p-2.5 bg-slate-50 border border-slate-300 rounded-xl text-center font-mono text-slate-800 outline-none focus:border-blue-500" /></div>
                    </div></div>
                    <div className="pt-3 border-t border-slate-100"><span className="text-[10px] uppercase font-bold text-slate-500 block mb-2">Near Vision (NV)</span>
                    <div className="grid grid-cols-3 gap-4">
                      <div><label className="text-[10px] text-slate-400 block mb-1">R-SPH</label><input type="text" placeholder="0.00" value={clNvSphRight} onChange={e => setClNvSphRight(e.target.value)} className="w-full p-2.5 bg-slate-50 border border-slate-300 rounded-xl text-center font-mono text-slate-800 outline-none focus:border-blue-500 focus:bg-white" /></div>
                      <div><label className="text-[10px] text-slate-400 block mb-1">R-CYL</label><input type="text" placeholder="0.00" value={clNvCylRight} onChange={e => setClNvCylRight(e.target.value)} className="w-full p-2.5 bg-slate-50 border border-slate-300 rounded-xl text-center font-mono text-slate-800 outline-none focus:border-blue-500 focus:bg-white" /></div>
                      <div><label className="text-[10px] text-slate-400 block mb-1">R-AXIS</label><input type="text" placeholder="0" value={clNvAxisRight} onChange={e => setClNvAxisRight(e.target.value)} className="w-full p-2.5 bg-slate-50 border border-slate-300 rounded-xl text-center font-mono text-slate-800 outline-none focus:border-blue-500 focus:bg-white" /></div>
                    </div></div>
                    <div className="pt-3 border-t border-slate-100"><span className="text-[10px] uppercase font-bold text-slate-500 block mb-2">Additional Parameters</span>
                    <div className="grid grid-cols-1 gap-4">
                      <div><label className="text-[10px] text-slate-400 block mb-1">R-ADD</label><input type="text" placeholder="Add" value={clAddRight} onChange={e => setClAddRight(e.target.value)} className="w-full p-2.5 bg-slate-50 border border-slate-300 rounded-xl text-center font-mono text-slate-800 outline-none focus:border-blue-500 focus:bg-white" /></div>
                    </div></div>
                  </div>
                  <div className="space-y-5 bg-white p-6 rounded-2xl border border-slate-200 shadow-sm"><span className="text-sm font-black uppercase tracking-widest block text-blue-600 border-b border-slate-100 pb-3 mb-4">LEFT CONTACT LENS</span>
                    <div><span className="text-[10px] uppercase font-bold text-slate-500 block mb-2">Distance Vision (DV)</span>
                    <div className="grid grid-cols-3 gap-4">
                      <div><label className="text-[10px] text-slate-400 block mb-1">L-SPH</label><input type="text" placeholder="0.00" value={clSphLeft} onChange={e => setClSphLeft(e.target.value)} className="w-full p-2.5 bg-slate-50 border border-slate-300 rounded-xl text-center font-mono text-slate-800 outline-none focus:border-blue-500" /></div>
                      <div><label className="text-[10px] text-slate-400 block mb-1">L-CYL</label><input type="text" placeholder="0.00" value={clCylLeft} onChange={e => setClCylLeft(e.target.value)} className="w-full p-2.5 bg-slate-50 border border-slate-300 rounded-xl text-center font-mono text-slate-800 outline-none focus:border-blue-500" /></div>
                      <div><label className="text-[10px] text-slate-400 block mb-1">L-AXIS</label><input type="text" placeholder="0" value={clAxisLeft} onChange={e => setAxisLeft(e.target.value)} className="w-full p-2.5 bg-slate-50 border border-slate-300 rounded-xl text-center font-mono text-slate-800 outline-none focus:border-blue-500" /></div>
                    </div></div>
                    <div className="pt-3 border-t border-slate-100"><span className="text-[10px] uppercase font-bold text-slate-500 block mb-2">Near Vision (NV)</span>
                    <div className="grid grid-cols-3 gap-4">
                      <div><label className="text-[10px] text-slate-400 block mb-1">L-SPH</label><input type="text" placeholder="0.00" value={clNvSphLeft} onChange={e => setClNvSphLeft(e.target.value)} className="w-full p-2.5 bg-slate-50 border border-slate-300 rounded-xl text-center font-mono text-slate-800 outline-none focus:border-blue-500 focus:bg-white" /></div>
                      <div><label className="text-[10px] text-slate-400 block mb-1">L-CYL</label><input type="text" placeholder="0.00" value={clNvCylLeft} onChange={e => setClNvCylLeft(e.target.value)} className="w-full p-2.5 bg-slate-50 border border-slate-300 rounded-xl text-center font-mono text-slate-800 outline-none focus:border-blue-500 focus:bg-white" /></div>
                      <div><label className="text-[10px] text-slate-400 block mb-1">L-AXIS</label><input type="text" placeholder="0" value={clNvAxisLeft} onChange={e => setClNvAxisLeft(e.target.value)} className="w-full p-2.5 bg-slate-50 border border-slate-300 rounded-xl text-center font-mono text-slate-800 outline-none focus:border-blue-500 focus:bg-white" /></div>
                    </div></div>
                    <div className="pt-3 border-t border-slate-100"><span className="text-[10px] uppercase font-bold text-slate-500 block mb-2">Additional Parameters</span>
                    <div className="grid grid-cols-1 gap-4">
                      <div><label className="text-[10px] text-slate-400 block mb-1">L-ADD</label><input type="text" placeholder="Add" value={clAddLeft} onChange={e => setClAddLeft(e.target.value)} className="w-full p-2.5 bg-slate-50 border border-slate-300 rounded-xl text-center font-mono text-slate-800 outline-none focus:border-blue-500 focus:bg-white" /></div>
                    </div></div>
                  </div>
                </div>
              )}
              {prescriptionTab === "transpose" && (
                <div className="p-10 text-center text-slate-500 font-bold border border-slate-200 rounded-2xl bg-white">
                  Transpose UI Logic Rendered Here (Matches styling of Eyewear Tab)
                </div>
              )}

              {/* SHARED FOOTER CONFIGURATIONS FOR ALL TABS */}
              <div className="mt-8 space-y-6 border-t border-slate-200 pt-6">
                <div className="space-y-3">
                  <label className="text-xs font-bold uppercase tracking-wider text-slate-500">Lens Configuration Type:</label>
                  <div className="flex flex-wrap gap-x-6 gap-y-3 text-sm text-slate-700 font-medium">
                    {['Constant Use', 'Reading Wear', 'Distance Wear', 'Single Vision', 'Progressive', 'Bifocal', 'Trifocal', 'Contact Lens'].map(type => (
                      <label key={type} className="flex items-center gap-2 cursor-pointer hover:text-purple-600 transition-colors">
                        <input type="checkbox" value={type} checked={lensTypes.includes(type)} onChange={() => toggleLensType(type)} className="accent-purple-600 w-4 h-4 cursor-pointer" />
                        {type}
                      </label>
                    ))}
                  </div>
                </div>
                
                <div className="flex flex-col md:flex-row gap-8 items-start md:items-center">
                  <div className="space-y-3">
                    <label className="text-xs font-bold uppercase tracking-wider text-slate-500 block">Count In Eye Testing Records?</label>
                    <div className="flex gap-6 text-sm text-slate-700 font-medium">
                      <label className="flex items-center gap-2 cursor-pointer hover:text-purple-600 transition-colors">
                        <input type="radio" name="eyeTest" value="Yes" checked={eyeTestRecord === 'Yes'} onChange={() => setEyeTestRecord('Yes')} className="accent-purple-600 w-4 h-4 cursor-pointer"/> Yes
                      </label>
                      <label className="flex items-center gap-2 cursor-pointer hover:text-purple-600 transition-colors">
                        <input type="radio" name="eyeTest" value="No" checked={eyeTestRecord === 'No'} onChange={() => setEyeTestRecord('No')} className="accent-purple-600 w-4 h-4 cursor-pointer"/> No
                      </label>
                    </div>
                  </div>
                </div>

                <div className="space-y-2">
                  <label className="text-xs font-bold uppercase tracking-wider text-slate-500">Diagnostic / Prescription Notes:</label>
                  <textarea className="w-full p-4 bg-slate-50 border border-slate-200 rounded-xl text-slate-800 outline-none focus:border-purple-500 transition-colors resize-y shadow-inner" placeholder="Any internal remarks or patient-specific observations..." value={prescriptionNotes} onChange={e => setPrescriptionNotes(e.target.value)} rows="3"></textarea>
                </div>
              </div>

              <div className="mt-8 flex justify-end">
                <button 
                  type="button"
                  onClick={() => setShowPrescriptionModal(false)}
                  className="px-10 py-4 bg-blue-600 hover:bg-blue-700 rounded-xl font-black text-sm uppercase tracking-widest text-white shadow-xl shadow-blue-200 transition-all active:scale-[0.98] flex items-center gap-2"
                >
                  <CheckCircle2 size={18} /> Cache & Return to Cart
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      <div className="flex-1 p-6 lg:p-10 space-y-8 overflow-x-hidden">
        
        {/* HEADER */}
        <div className="flex flex-col lg:flex-row lg:items-center justify-between p-6 bg-white border border-slate-200 rounded-3xl gap-6 shadow-sm">
          <div>
            <h1 className="text-3xl font-black text-slate-800 uppercase tracking-wider">Billing Command Center</h1>
             <div className="flex items-center gap-1.5 mt-1.5 text-sm text-slate-500 font-medium">
              <MapPin size={14} className="text-blue-500" />
              <span>Operating Branch: </span>
              <span className="bg-blue-50 text-blue-700 font-black px-3 py-1 rounded-xl border border-blue-100 text-xs tracking-widest uppercase shadow-sm">
                {storeName || "Loading..."}
              </span>
            </div>
          </div>

          <div className="flex bg-slate-100 p-2 rounded-2xl border border-slate-200 text-sm font-bold">
            <button onClick={() => { setActiveTab("newOrder"); resetForm(); }} className={`px-6 py-3 rounded-xl transition-all duration-200 ${activeTab === "newOrder" && !editOrderId ? "bg-white text-blue-600 shadow-md border border-slate-200" : "text-slate-500 hover:text-slate-800"}`}>New Order</button>
            <button onClick={() => { setActiveTab("salesHistory"); resetForm(); }} className={`px-6 py-3 rounded-xl transition-all duration-200 ${activeTab === "salesHistory" ? "bg-white text-blue-600 shadow-md border border-slate-200" : "text-slate-500 hover:text-slate-800"}`}>Master Sales History</button>
          </div>
        </div>

        {/* ALERTS */}
        <AnimatePresence>
          {systemError && (
            <motion.div initial={{ opacity: 0, y: -5 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0 }} className="p-4 bg-rose-50 border border-rose-200 text-rose-700 rounded-2xl flex items-center justify-between shadow-sm font-medium">
              <div className="flex items-center gap-3">
                <AlertCircle size={20} className="text-rose-600 shrink-0" />
                <span>{systemError}</span>
              </div>
              <button onClick={() => setSystemError(null)} className="text-rose-400 hover:text-rose-600 transition">
                <X size={18} />
              </button>
            </motion.div>
          )}

          {lastInvoiceNo && (
            <motion.div initial={{ opacity: 0, y: -5 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0 }} className="p-4 bg-emerald-50 border border-emerald-200 text-emerald-800 rounded-2xl flex items-center justify-between shadow-sm font-medium">
              <div className="flex items-center gap-3">
                <CheckCircle2 size={20} className="text-emerald-600 shrink-0" />
                <span>Order committed successfully! Invoice Reference: <strong className="font-mono font-black underline">{lastInvoiceNo}</strong></span>
              </div>
              <div className="flex items-center gap-3">
                <button 
                  onClick={() => {
                    const targetSale = salesHistoryData.find(s => s.invoiceNo === lastInvoiceNo);
                    if (targetSale) handlePrintReceipt(targetSale, targetSale.financials?.balanceDue > 0 ? 'advance' : 'final');
                  }}
                  className="px-4 py-1.5 bg-emerald-600 hover:bg-emerald-700 text-white font-bold rounded-xl text-xs uppercase flex items-center gap-1.5 shadow-sm transition active:scale-95"
                >
                  <Printer size={14} /> Print Receipt
                </button>
                
                {/* WHATSAPP TRIGGER FROM CHECKOUT BANNER */}
                <button 
                  onClick={() => {
                    const targetSale = salesHistoryData.find(s => s.invoiceNo === lastInvoiceNo);
                    if (targetSale) {
                       setContactMethod('whatsapp'); 
                       setContactOrder(targetSale);
                       setShowContactModal(true);
                    }
                  }}
                  className="px-4 py-1.5 bg-green-600 hover:bg-green-700 text-white font-bold rounded-xl text-xs uppercase flex items-center gap-1.5 shadow-sm transition active:scale-95"
                >
                  <MessageCircle size={14} /> WhatsApp
                </button>

                {/* SMS TRIGGER FROM CHECKOUT BANNER */}
                <button 
                  onClick={() => {
                    const targetSale = salesHistoryData.find(s => s.invoiceNo === lastInvoiceNo);
                    if (targetSale) {
                       setContactMethod('sms'); 
                       setContactOrder(targetSale);
                       setShowContactModal(true);
                    }
                  }}
                  className="px-4 py-1.5 bg-blue-600 hover:bg-blue-700 text-white font-bold rounded-xl text-xs uppercase flex items-center gap-1.5 shadow-sm transition active:scale-95"
                >
                  <MessageSquare size={14} /> SMS
                </button>

                <button onClick={() => setLastInvoiceNo("")} className="text-emerald-500 hover:text-emerald-700 transition">
                  <X size={18} />
                </button>
              </div>
            </motion.div>
          )}
        </AnimatePresence>

        {/* ========================================== */}
        {/* TAB 1: NEW ORDER / POS MATRIX DESK */}
        {/* ========================================== */}
        {activeTab === "newOrder" && (
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
            
            {/* LEFT COLUMN: CATALOG, CUSTOM INJECTION & BILLING CART */}
            <div className="col-span-1 lg:col-span-7 space-y-6">
              
              {editOrderId && (
                <div className="bg-blue-50 border border-blue-200 p-4 rounded-2xl flex justify-between items-center shadow-sm">
                  <div className="flex items-center gap-3 text-blue-700">
                    <Edit3 size={20}/>
                    <div>
                      <h3 className="font-black uppercase tracking-wider text-xs">Full Order Edit Mode Active</h3>
                      <p className="text-[10px] font-medium opacity-80 font-mono mt-0.5">Editing: {orderReference}</p>
                    </div>
                  </div>
                  <button onClick={resetForm} className="px-4 py-2 bg-white text-blue-600 hover:bg-blue-600 hover:text-white border border-blue-200 text-xs font-bold uppercase rounded-xl transition">
                    Cancel Edit
                  </button>
                </div>
              )}

              {/* SKU / Barcode Scanner Input & Quick Add Categories */}
              <div className="relative">
                <div className="flex items-center bg-white border border-slate-300 rounded-2xl p-2 shadow-sm focus-within:border-blue-500 transition-colors">
                  <Search size={20} className="text-slate-400 mx-3 shrink-0" />
                  <input
                    type="text"
                    placeholder="Scan Barcode or Type Product Name / SKU Code..."
                    value={skuSearchQuery}
                    onChange={e => setSkuSearchQuery(e.target.value)}
                    className="w-full py-2 outline-none text-slate-800 font-bold placeholder:text-slate-400 placeholder:font-normal text-sm"
                  />
                  {skuSearchQuery && (
                    <button onClick={() => setSkuSearchQuery("")} className="text-slate-400 hover:text-slate-600 p-1 mr-1">
                      <X size={18} />
                    </button>
                  )}
                </div>

                {/* NEW: QUICK ADD CATEGORY BUTTONS */}
                <div className="flex flex-wrap gap-2 mt-3">
                  {["Frame", "Lens", "Sunglasses", "Contact Lens", "Solution", "Other", "Non Chargeable"].map((cat) => (
                    <button 
                      key={cat} 
                      onClick={() => { setSelectedProductType(cat); setProductTypeSearchQuery(""); setShowProductTypePopup(true); }} 
                      className="px-3 py-1.5 bg-white border border-slate-200 text-slate-600 text-[10px] font-black uppercase tracking-wider rounded-xl hover:bg-blue-50 hover:text-blue-600 hover:border-blue-200 transition-colors shadow-sm"
                    >
                      + Add {cat}
                    </button>
                  ))}
                </div>

                {/* Live Search Auto-Suggest Drawer */}
                {scannedMatches.length > 0 && (
                  <div className="absolute top-[60px] left-0 right-0 mt-2 bg-white border border-slate-200 rounded-2xl shadow-2xl z-50 max-h-72 overflow-y-auto divide-y divide-slate-100">
                    {scannedMatches.map(prod => (
                      <div 
                        key={prod.id} 
                        onClick={() => addToCartAction(prod)} 
                        className="p-4 hover:bg-blue-50/80 cursor-pointer flex justify-between items-center transition group"
                      >
                        <div>
                          <div className="font-black text-slate-800 group-hover:text-blue-700 transition-colors">{prod.productName}</div>
                          <div className="text-xs text-slate-400 font-mono mt-0.5">SKU: {prod.productCode} | Type: {prod.productType || 'Standard'}</div>
                        </div>
                        <div className="text-right">
                          <div className="font-black text-blue-600">₹{Number(prod.retailPrice).toLocaleString()}</div>
                          <div className="text-xs font-medium mt-0.5">
                            Stock: <span className={Number(prod.quantity) > 5 ? "text-emerald-600 font-bold" : "text-rose-600 font-black"}>{prod.quantity}</span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* Instant Custom Product Injection Toolbar */}
              <div className="bg-white p-4 rounded-2xl border border-slate-200 shadow-sm flex flex-wrap gap-2.5 items-center justify-between">
                <span className="text-xs font-black uppercase text-slate-400 tracking-wider flex items-center gap-1">
                  <Plus size={14}/> Custom Entry
                </span>
                <div className="flex flex-wrap flex-1 gap-2 max-w-full sm:max-w-none">
                  <input 
                    type="text" 
                    placeholder="SKU (e.g. EXTRA01)" 
                    value={customItem.productCode} 
                    onChange={e => setCustomItem({...customItem, productCode: e.target.value})} 
                    className="p-2 text-xs bg-slate-50 border border-slate-200 rounded-xl outline-none focus:bg-white font-mono uppercase w-28 font-bold text-slate-700" 
                  />
                  <input 
                    type="text" 
                    placeholder="Custom Service / Item Description" 
                    value={customItem.productName} 
                    onChange={e => setCustomItem({...customItem, productName: e.target.value})} 
                    className="p-2 text-xs bg-slate-50 border border-slate-200 rounded-xl outline-none focus:bg-white flex-1 min-w-[150px] font-bold text-slate-700" 
                  />
                  <input 
                    type="number" 
                    placeholder="Price ₹" 
                    value={customItem.customPrice} 
                    onChange={e => setCustomItem({...customItem, customPrice: e.target.value})} 
                    className="p-2 text-xs bg-slate-50 border border-slate-200 rounded-xl outline-none focus:bg-white w-24 font-mono font-bold text-blue-600" 
                  />
                </div>
                <button 
                  onClick={handleInjectCustomProduct} 
                  className="px-4 py-2 bg-slate-900 hover:bg-blue-600 text-white rounded-xl font-bold transition flex items-center gap-1 text-xs uppercase tracking-wider shrink-0 shadow-sm"
                >
                  Inject
                </button>
              </div>

              {/* Active Cart Ledger Table */}
              <div className="bg-white border border-slate-200 rounded-3xl shadow-sm overflow-hidden">
                <div className="p-4 bg-slate-50 border-b border-slate-100 flex justify-between items-center">
                  <h3 className="font-black text-slate-700 uppercase tracking-wider text-xs flex items-center gap-2">
                    <ShoppingBag size={16} className="text-blue-600"/> Current Ledger Items ({billingCart.length})
                  </h3>
                  {billingCart.length > 0 && (
                    <button onClick={() => setBillingCart([])} className="text-xs font-bold text-rose-500 hover:text-rose-700 transition flex items-center gap-1">
                      <Trash2 size={13}/> Wipe Cart
                    </button>
                  )}
                </div>

                {billingCart.length === 0 ? (
                  <div className="p-12 text-center text-slate-400 space-y-3">
                    <ShoppingCart size={40} className="mx-auto text-slate-300 stroke-[1.5]" />
                    <p className="text-sm font-medium">Cart is entirely void. Scan an item or inject a custom product above.</p>
                  </div>
                ) : (
                  <div className="divide-y divide-slate-100 overflow-x-auto">
                    <table className="w-full text-left border-collapse">
                      <thead>
                        <tr className="text-[10px] font-black uppercase text-slate-400 tracking-wider bg-slate-50/50">
                          <th className="p-3 pl-4">Product</th>
                          <th className="p-3 text-right">Unit Rate</th>
                          <th className="p-3 text-center">Qty</th>
                          <th className="p-3 text-right">Custom Disc (₹)</th>
                          <th className="p-3 text-right">Net Price</th>
                          <th className="p-3 pr-4 text-center"></th>
                        </tr>
                      </thead>
                      <tbody className="text-xs font-bold divide-y divide-slate-100">
                        {billingCart.map(item => {
                          const unitPrice = Number(item.retailPrice) || 0;
                          const qty = Number(item.cartQuantity) || 1;
                          const disc = Number(item.customDiscount) || 0;
                          const rowTotal = (unitPrice * qty) - disc;

                          return (
                            <tr key={item.id} className="hover:bg-slate-50/60 transition-colors">
                              <td className="p-3 pl-4">
                                <div className="text-slate-800">{item.productName}</div>
                                <div className="text-[10px] text-slate-400 font-mono font-normal">
                                  {item.productCode} {item.isCustomItem && <span className="text-purple-600 font-bold bg-purple-50 px-1 py-0.5 rounded ml-1">CUSTOM</span>}
                                </div>
                                {disc > 0 && (
                                  <div className="text-[10px] text-rose-500 font-black mt-0.5 flex items-center gap-1">
                                    <Percent size={10} /> Discount Applied: ₹{disc.toFixed(2)}
                                  </div>
                                )}
                              </td>
                              <td className="p-3 text-right font-mono text-slate-600">₹{unitPrice.toLocaleString()}</td>
                              <td className="p-3 text-center">
                                <input
                                  type="number"
                                  min="1"
                                  value={item.cartQuantity}
                                  onChange={e => updateCartQty(item.id, e.target.value)}
                                  className="w-14 p-1 text-center bg-slate-100 border border-slate-200 rounded-lg outline-none focus:bg-white focus:border-blue-500 font-mono font-bold"
                                />
                              </td>
                              <td className="p-3 text-right">
                                <input
                                  type="number"
                                  min="0"
                                  placeholder="0"
                                  value={item.customDiscount || ""}
                                  onChange={e => updateCartDiscount(item.id, e.target.value)}
                                  className="w-16 p-1 text-right bg-slate-100 border border-slate-200 rounded-lg outline-none focus:bg-white focus:border-purple-500 font-mono text-purple-700 font-bold"
                                />
                              </td>
                              <td className="p-3 text-right font-mono font-black text-blue-600">₹{rowTotal.toLocaleString()}</td>
                              <td className="p-3 pr-4 text-center">
                                <button onClick={() => updateCartQty(item.id, 0)} className="text-slate-300 hover:text-rose-500 transition-colors p-1">
                                  <X size={16} />
                                </button>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}

                {/* Prescription Check Banner inside Cart */}
                <div className="p-4 bg-purple-50/60 border-t border-purple-100 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
                  <div className="flex items-center gap-3">
                    <div className="p-2 bg-purple-600 text-white rounded-xl shadow-sm"><Stethoscope size={18}/></div>
                    <div>
                      <div className="text-xs font-black uppercase tracking-wider text-purple-950">Optical Prescription Link</div>
                      <div className="text-[11px] text-purple-700 font-medium mt-0.5">
                        {patientName || doctorName ? `Attached: ${patientName || 'No-Name'} (Ref: Dr. ${doctorName || 'Self'})` : "No eye diagnostic parameters tethered to this order yet."}
                      </div>
                    </div>
                  </div>
                  <button 
                    onClick={() => setShowPrescriptionModal(true)}
                    className="px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white text-xs font-black uppercase rounded-xl tracking-wider transition shadow-sm w-full sm:w-auto shrink-0"
                  >
                    {patientName || doctorName ? "Modify Rx Matrix" : "Attach Rx Data"}
                  </button>
                </div>
              </div>
            </div>

            {/* RIGHT COLUMN: CUSTOMER DATA, TAX ENGINE & FINANCIAL CHECKOUT */}
            <div className="col-span-1 lg:col-span-5 space-y-6">
              
              {/* Customer Metadata Card */}
              <div className="bg-white border border-slate-200 rounded-3xl p-6 shadow-sm space-y-4">
                <div className="flex justify-between items-center border-b border-slate-100 pb-3">
                  <h3 className="font-black text-slate-800 uppercase tracking-wider text-xs flex items-center gap-2">
                    <User size={16} className="text-blue-600"/> Customer Profile Assignment
                  </h3>
                  <span className="text-[10px] font-bold text-slate-400 bg-slate-100 px-2 py-0.5 rounded-full">Auto-fetches on Phone blur</span>
                </div>

                <div className="grid grid-cols-2 gap-3">
                  <div>
                    <label className="text-[10px] font-black uppercase text-slate-400 block mb-1">Primary Mobile *</label>
                    <input 
                      type="tel" 
                      placeholder="10-Digit No" 
                      value={customerPhone} 
                      onChange={e => setCustomerPhone(e.target.value)} 
                      onBlur={handlePhoneBlurCustomer}
                      className="w-full p-2.5 bg-slate-50 border border-slate-200 rounded-xl text-xs font-mono font-bold outline-none focus:bg-white focus:border-blue-500"
                    />
                  </div>
                  <div>
                    <label className="text-[10px] font-black uppercase text-slate-400 block mb-1">Alt / WhatsApp</label>
                    <input 
                      type="tel" 
                      value={customerPhone2} 
                      onChange={e => setCustomerPhone2(e.target.value)} 
                      className="w-full p-2.5 bg-slate-50 border border-slate-200 rounded-xl text-xs font-mono font-bold outline-none focus:bg-white focus:border-blue-500"
                    />
                  </div>
                  <div className="col-span-2">
                    <label className="text-[10px] font-black uppercase text-slate-400 block mb-1">Customer Full Name *</label>
                    <input 
                      type="text" 
                      placeholder="e.g. Rajesh Kumar" 
                      value={customerName} 
                      onChange={e => setCustomerName(e.target.value)} 
                      className="w-full p-2.5 bg-slate-50 border border-slate-200 rounded-xl text-xs font-bold text-slate-800 outline-none focus:bg-white focus:border-blue-500"
                    />
                  </div>
                  <div>
                    <label className="text-[10px] font-black uppercase text-slate-400 block mb-1">Date of Birth</label>
                    <input 
                      type="date" 
                      value={customerDob} 
                      onChange={e => setCustomerDob(e.target.value)} 
                      className="w-full p-2 bg-slate-50 border border-slate-200 rounded-xl text-xs font-mono font-bold outline-none focus:bg-white text-slate-700"
                    />
                  </div>
                  <div>
                    <label className="text-[10px] font-black uppercase text-slate-400 block mb-1">Anniversary</label>
                    <input 
                      type="date" 
                      value={customerAnniversary} 
                      onChange={e => setCustomerAnniversary(e.target.value)} 
                      className="w-full p-2 bg-slate-50 border border-slate-200 rounded-xl text-xs font-mono font-bold outline-none focus:bg-white text-slate-700"
                    />
                  </div>
                  <div className="col-span-2">
                    <label className="text-[10px] font-black uppercase text-slate-400 block mb-1">Street Address</label>
                    <input 
                      type="text" 
                      placeholder="House, Building, Landmark" 
                      value={customerAddress} 
                      onChange={e => setCustomerAddress(e.target.value)} 
                      className="w-full p-2.5 bg-slate-50 border border-slate-200 rounded-xl text-xs font-bold outline-none focus:bg-white text-slate-700"
                    />
                  </div>
                  <div>
                    <label className="text-[10px] font-black uppercase text-slate-400 block mb-1">Locality / Area</label>
                    <input 
                      type="text" 
                      value={customerLocality} 
                      onChange={e => setCustomerLocality(e.target.value)} 
                      className="w-full p-2 bg-slate-50 border border-slate-200 rounded-xl text-xs font-bold outline-none focus:bg-white text-slate-700"
                    />
                  </div>
                  <div>
                    <label className="text-[10px] font-black uppercase text-slate-400 block mb-1">Pincode</label>
                    <input 
                      type="text" 
                      maxLength="6" 
                      value={customerPincode} 
                      onChange={e => setCustomerPincode(e.target.value)} 
                      className="w-full p-2 bg-slate-50 border border-slate-200 rounded-xl text-xs font-mono font-bold outline-none focus:bg-white text-slate-700"
                    />
                  </div>
                  <div>
                    <label className="text-[10px] font-black uppercase text-slate-400 block mb-1">State / Province</label>
                    <select 
                      value={customerState} 
                      onChange={e => setCustomerState(e.target.value)}
                      className="w-full p-2 bg-slate-50 border border-slate-200 rounded-xl text-xs font-bold outline-none focus:bg-white text-slate-700"
                    >
                      <option value="">-- Select State --</option>
                      {INDIAN_STATES.map(st => <option key={st} value={st}>{st}</option>)}
                    </select>
                  </div>
                  <div>
                    <label className="text-[10px] font-black uppercase text-slate-400 block mb-1">Company / GSTIN</label>
                    <input 
                      type="text" 
                      placeholder="Optional GST" 
                      value={customerCompany} 
                      onChange={e => setCustomerCompany(e.target.value)} 
                      className="w-full p-2 bg-slate-50 border border-slate-200 rounded-xl text-xs font-bold uppercase font-mono outline-none focus:bg-white text-slate-700"
                    />
                  </div>
                </div>
              </div>

              {/* Order Logistics & Rep settings */}
              <div className="bg-white border border-slate-200 rounded-3xl p-6 shadow-sm space-y-4">
                <h3 className="font-black text-slate-800 uppercase tracking-wider text-xs border-b border-slate-100 pb-3 flex items-center gap-2">
                  <FileText size={16} className="text-purple-600"/> Order Logistics & Rep
                </h3>

                <div className="grid grid-cols-2 gap-3">
                  <div className="col-span-2">
                    <label className="text-[10px] font-black uppercase text-slate-400 block mb-1">Attending Sales Rep *</label>
                    <select
                      value={salesperson}
                      onChange={e => setSalesperson(e.target.value)}
                      className="w-full p-2.5 bg-slate-50 border border-slate-200 rounded-xl text-xs font-bold text-slate-800 outline-none focus:bg-white focus:border-purple-500 cursor-pointer"
                    >
                      <option value="">-- Select Employee --</option>
                      {storeEmployees.map(emp => (
                        <option key={emp.id} value={emp.name || emp.id}>{emp.name || emp.id}</option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label className="text-[10px] font-black uppercase text-slate-400 block mb-1">Booking Date</label>
                    <input 
                      type="date" 
                      value={salesDate} 
                      onChange={e => setSalesDate(e.target.value)} 
                      className="w-full p-2 bg-slate-50 border border-slate-200 rounded-xl text-xs font-mono font-bold outline-none text-slate-700"
                    />
                  </div>
                  <div>
                    <label className="text-[10px] font-black uppercase text-slate-400 block mb-1">Est. Delivery Date</label>
                    <input 
                      type="date" 
                      value={deliveryDate} 
                      onChange={e => setDeliveryDate(e.target.value)} 
                      className="w-full p-2 bg-slate-50 border border-slate-200 rounded-xl text-xs font-mono font-bold outline-none text-slate-700"
                    />
                  </div>
                  <div className="col-span-2">
                    <label className="text-[10px] font-black uppercase text-slate-400 block mb-1">Manual Invoice Overwrite #</label>
                    <input 
                      type="text" 
                      placeholder="Leave blank for auto-generator" 
                      value={orderReference} 
                      onChange={e => setOrderReference(e.target.value)} 
                      className="w-full p-2 bg-slate-50 border border-slate-200 rounded-xl text-xs font-mono font-bold uppercase outline-none focus:bg-white text-slate-800"
                    />
                  </div>
                </div>
              </div>

              {/* Financial Matrix Checkout Terminal */}
              <div className="bg-slate-900 text-white rounded-3xl p-6 shadow-xl space-y-4">
                <h3 className="font-black uppercase tracking-wider text-xs border-b border-slate-800 pb-3 flex items-center justify-between text-slate-300">
                  <span className="flex items-center gap-2"><CreditCard size={16} className="text-emerald-400"/> Financial Matrix</span>
                  <span className="text-[10px] font-mono text-emerald-400 bg-emerald-950/80 px-2 py-0.5 rounded border border-emerald-800">Save: ₹{financials.totalYouSave.toLocaleString()}</span>
                </h3>

                <div className="space-y-2.5 text-xs font-bold">
                  <div className="flex justify-between text-slate-400 font-medium">
                    <span>Baseline Subtotal</span>
                    <span className="font-mono text-white font-bold">₹{financials.subtotal.toLocaleString()}</span>
                  </div>
                  {financials.totalDiscount > 0 && (
                    <div className="flex justify-between text-purple-400">
                      <span>Total Item Discounts</span>
                      <span className="font-mono">- ₹{financials.totalDiscount.toLocaleString()}</span>
                    </div>
                  )}

                  {/* OVERALL DISCOUNT INPUT */}
                  <div className="py-3 border-t border-slate-800 flex justify-between items-center gap-2 mt-2">
                    <span className="text-slate-300 flex items-center gap-1.5"><Percent size={14} className="text-purple-400" /> Overall Bill Discount</span>
                    <div className="flex items-center gap-1.5">
                      <select 
                        value={overallDiscountType} 
                        onChange={e => setOverallDiscountType(e.target.value)} 
                        className="bg-slate-800 text-slate-300 border border-slate-700 rounded-lg p-1.5 text-[11px] font-bold outline-none cursor-pointer"
                      >
                        <option value="amount">Flat (₹)</option>
                        <option value="percent">Percent (%)</option>
                      </select>
                      <input 
                        type="number" 
                        min="0"
                        placeholder="0"
                        value={overallDiscountValue}
                        onChange={e => setOverallDiscountValue(e.target.value)}
                        className="w-20 p-1.5 bg-slate-800 border border-slate-700 rounded-lg text-right font-mono text-purple-400 font-bold outline-none focus:border-purple-500"
                      />
                    </div>
                  </div>

                  {/* NEW ROUND OFF BLOCK */}
                  <div className="py-3 border-b border-slate-800 flex justify-between items-center gap-2 mt-2">
                    <span className="text-slate-300 flex items-center gap-1.5">Round Off (+/-)</span>
                    <div className="flex items-center gap-1.5">
                      <button 
                        type="button" 
                        onClick={() => {
                          const target = window.prompt("Enter Target Final Customer Price:\n(Calculates required discount / round-off)");
                          if (target !== null && !isNaN(Number(target))) {
                              setRoundOff((Number(target) - financials.unroundedNetPayable).toFixed(2));
                          }
                        }} 
                        className="px-2 py-1.5 bg-slate-800 border border-slate-700 hover:bg-slate-700 text-[10px] uppercase font-black rounded-lg text-emerald-400 transition-colors"
                      >
                        Target
                      </button>
                      <button 
                        type="button" 
                        onClick={() => setRoundOff((Math.round(financials.unroundedNetPayable) - financials.unroundedNetPayable).toFixed(2))} 
                        className="px-2 py-1.5 bg-slate-800 border border-slate-700 hover:bg-slate-700 text-[10px] uppercase font-black rounded-lg text-emerald-400 transition-colors"
                      >
                        Auto
                      </button>
                      <input 
                        type="number" 
                        placeholder="0.00"
                        value={roundOff}
                        onChange={e => setRoundOff(e.target.value)}
                        className="w-20 p-1.5 bg-slate-800 border border-slate-700 rounded-lg text-right font-mono text-emerald-400 font-bold outline-none focus:border-emerald-500"
                      />
                    </div>
                  </div>

                  {/* Tax Engine Configurator */}
                  <div className="py-3 border-b border-slate-800 flex justify-between items-center gap-2">
                    <div className="flex items-center gap-2">
                      <span className="text-slate-400">GST Rule:</span>
                      <select value={taxRule} onChange={e => setTaxRule(e.target.value)} className="bg-slate-800 text-white border border-slate-700 rounded-lg p-1 text-[11px] font-bold outline-none cursor-pointer">
                        <option value="include">Inclusive</option>
                        <option value="exclude">Exclusive</option>
                        <option value="none">Zero Tax</option>
                      </select>
                    </div>
                    {taxRule !== "none" && (
                      <div className="flex items-center gap-1 font-mono">
                        <select value={taxPercentage} onChange={e => setTaxPercentage(e.target.value)} className="bg-slate-800 text-emerald-400 border border-slate-700 rounded-lg p-1 text-[11px] font-bold outline-none cursor-pointer">
                          <option value="5">5%</option><option value="12">12%</option><option value="18">18%</option>
                        </select>
                        <span className="text-slate-400 text-[10px]">(₹{financials.computedTax.toFixed(0)})</span>
                      </div>
                    )}
                  </div>

                  <div className="flex justify-between items-center pt-2">
                    <span className="text-slate-400">Net Payable Amount</span>
                    <span className="text-lg font-mono font-black text-emerald-400">₹{financials.netPayable.toLocaleString()}</span>
                  </div>

                  {/* Advance Collection */}
                  <div className="grid grid-cols-2 gap-3 pt-2">
                    <div>
                      <label className="text-[10px] uppercase text-slate-400 block mb-1">Advance Deposit (₹)</label>
                      <input 
                        type="number" 
                        min="0"
                        max={financials.netPayable}
                        value={advancePaid} 
                        onChange={e => setAdvancePaid(e.target.value)}
                        placeholder="0.00"
                        className="w-full p-2 bg-slate-800 border border-slate-700 rounded-xl font-mono text-sm text-emerald-400 font-black outline-none focus:border-emerald-500"
                      />
                    </div>
                    <div>
                      <label className="text-[10px] uppercase text-slate-400 block mb-1">Payment Channel</label>
                      <select value={paymentMode} onChange={e => {setPaymentMode(e.target.value); setPosPaymentDetails("");}} className="w-full p-2 bg-slate-800 border border-slate-700 rounded-xl text-xs font-bold text-white outline-none cursor-pointer mb-2">
                        <option>CASH</option><option>UPI / GPay</option><option>Credit Card</option><option>Bank Transfer</option>
                      </select>
                      {(paymentMode === "UPI / GPay" || paymentMode === "Credit Card") && (
                        <input
                          type="text"
                          placeholder="Txn / Card No"
                          value={posPaymentDetails}
                          onChange={e => setPosPaymentDetails(e.target.value)}
                          className="w-full p-2 bg-slate-800 border border-emerald-500 rounded-xl font-mono text-xs text-white outline-none"
                        />
                      )}
                    </div>
                  </div>

                  {/* Balance output banner */}
                  <div className={`p-3 rounded-2xl border text-center mt-3 flex justify-between items-center ${financials.balanceDue > 0 ? "bg-amber-950/40 border-amber-800 text-amber-300" : "bg-emerald-950/40 border-emerald-800 text-emerald-300"}`}>
                    <span className="text-xs font-black uppercase tracking-wider">Balance Due</span>
                    <span className="text-xl font-mono font-black">₹{Math.max(0, financials.balanceDue).toLocaleString()}</span>
                  </div>
                </div>

                {/* Core Commit Transaction Triggers */}
                <div className="grid grid-cols-2 gap-3 pt-4">
                  {editOrderId ? (
                    <button
                      type="button"
                      disabled={isProcessing || billingCart.length === 0}
                      onClick={() => commitInvoiceTransaction(false)}
                      className="col-span-2 py-3.5 bg-blue-600 hover:bg-blue-500 disabled:bg-slate-800 disabled:text-slate-600 text-white font-black uppercase tracking-wider rounded-2xl shadow-lg shadow-blue-900/30 transition active:scale-95 text-xs flex flex-col items-center justify-center gap-0.5"
                    >
                      <span>Update Full Order</span>
                    </button>
                  ) : (
                    <>
                      <button
                        type="button"
                        disabled={isProcessing || billingCart.length === 0}
                        onClick={() => commitInvoiceTransaction(false)}
                        className="py-3.5 bg-amber-600 hover:bg-amber-500 disabled:bg-slate-800 disabled:text-slate-600 text-white font-black uppercase tracking-wider rounded-2xl shadow-lg shadow-amber-900/30 transition active:scale-95 text-xs flex flex-col items-center justify-center gap-0.5"
                      >
                        <span>Save Order</span>
                        <span className="text-[9px] font-normal opacity-80">(Advance / Pending)</span>
                      </button>

                      <button
                        type="button"
                        disabled={isProcessing || billingCart.length === 0 || financials.balanceDue > 0}
                        onClick={() => commitInvoiceTransaction(true)}
                        className="py-3.5 bg-emerald-600 hover:bg-emerald-500 disabled:bg-slate-800 disabled:text-slate-600 text-white font-black uppercase tracking-wider rounded-2xl shadow-lg shadow-emerald-900/30 transition active:scale-95 text-xs flex flex-col items-center justify-center gap-0.5"
                      >
                        <span>Direct Invoice</span>
                        <span className="text-[9px] font-normal opacity-80">(100% Cash Settled)</span>
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>

          </div>
        )}

        {/* ========================================== */}
        {/* TAB 2: MASTER SALES LEDGER HISTORY */}
        {/* ========================================== */}
        {activeTab === "salesHistory" && (
          <div className="bg-white border border-slate-200 rounded-3xl p-6 lg:p-8 space-y-6 shadow-sm">
            
            {/* Filter Toolbar */}
            <div className="flex flex-wrap items-center justify-between gap-4 pb-6 border-b border-slate-100">
              <div className="flex items-center gap-3">
                <History className="text-blue-600 shrink-0" size={24} />
                <div>
                  <h2 className="text-xl font-black text-slate-800 uppercase tracking-wider">Branch Sales History</h2>
                  <p className="text-xs text-slate-400 font-medium mt-0.5">Showing logs for {resolvedBranchName}</p>
                </div>
              </div>

              <div className="flex flex-wrap items-center gap-3">
                <input 
                  type="text" 
                  placeholder="Search Inv / Name / Phone..." 
                  value={filterSearch} 
                  onChange={e => setFilterSearch(e.target.value)} 
                  className="px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-xl text-xs font-bold outline-none w-56 focus:border-blue-500 transition-colors placeholder:font-normal" 
                />
                
                <select 
                  value={filterStatus} 
                  onChange={e => setFilterStatus(e.target.value)} 
                  className="px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-xl text-xs font-bold outline-none cursor-pointer focus:border-blue-500 transition-colors"
                >
                  <option value="">All Statuses</option>
                  <option value="Pending">Pending / Advance</option>
                  <option value="Completed">Settled</option>
                </select>

                <div className="flex items-center gap-2 bg-slate-50 border border-slate-200 rounded-xl px-3 py-2 text-xs font-bold text-slate-600">
                  <Calendar size={14} className="text-slate-400"/>
                  <span>Start:</span>
                  <input type="date" value={startDate} onChange={e => setStartDate(e.target.value)} className="bg-transparent outline-none font-mono cursor-pointer" />
                </div>
                
                <div className="flex items-center gap-2 bg-slate-50 border border-slate-200 rounded-xl px-3 py-2 text-xs font-bold text-slate-600">
                  <Calendar size={14} className="text-slate-400"/>
                  <span>End:</span>
                  <input type="date" value={endDate} onChange={e => setEndDate(e.target.value)} className="bg-transparent outline-none font-mono cursor-pointer" />
                </div>
                
                {(startDate || endDate || filterSearch || filterStatus) && (
                  <button onClick={() => { setStartDate(""); setEndDate(""); setFilterSearch(""); setFilterStatus(""); }} className="px-4 py-2 bg-slate-100 hover:bg-rose-100 hover:text-rose-600 text-slate-600 font-bold text-xs rounded-xl transition">
                    Reset
                  </button>
                )}
              </div>
            </div>

            {/* Top Stat Metrics */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              <div className="bg-slate-50 p-4 rounded-2xl border border-slate-100 flex items-center justify-between">
                <div>
                  <span className="text-xs font-bold uppercase text-slate-400 block">Total Net Volume</span>
                  <span className="text-2xl font-black font-mono text-slate-800 mt-1 block">
                    ₹{completedSalesLedger.reduce((acc, curr) => acc + (curr.financials?.netPayable || 0), 0).toLocaleString()}
                  </span>
                </div>
                <div className="w-12 h-12 rounded-xl bg-blue-100 text-blue-600 flex items-center justify-center font-black">₹</div>
              </div>

              <div className="bg-slate-50 p-4 rounded-2xl border border-slate-100 flex items-center justify-between">
                <div>
                  <span className="text-xs font-bold uppercase text-slate-400 block">Collections Realized</span>
                  <span className="text-2xl font-black font-mono text-emerald-600 mt-1 block">
                    ₹{completedSalesLedger.reduce((acc, curr) => acc + (curr.checkout?.totalAmountPaid || curr.checkout?.advancePaid || 0), 0).toLocaleString()}
                  </span>
                </div>
                <div className="w-12 h-12 rounded-xl bg-emerald-100 text-emerald-600 flex items-center justify-center"><CheckCircle2 size={24}/></div>
              </div>

              <div className="bg-slate-50 p-4 rounded-2xl border border-slate-100 flex items-center justify-between">
                <div>
                  <span className="text-xs font-bold uppercase text-slate-400 block">Outstanding Credits</span>
                  <span className="text-2xl font-black font-mono text-amber-600 mt-1 block">
                    ₹{completedSalesLedger.reduce((acc, curr) => acc + (curr.financials?.balanceDue || 0), 0).toLocaleString()}
                  </span>
                </div>
                <div className="w-12 h-12 rounded-xl bg-amber-100 text-amber-600 flex items-center justify-center"><AlertCircle size={24}/></div>
              </div>
            </div>

            {/* Master Ledger Data Table */}
            <div className="border border-slate-200 rounded-3xl overflow-hidden shadow-sm">
              <div className="overflow-x-auto">
                <table className="w-full text-left border-collapse">
                  <thead>
                    <tr className="text-[10px] font-black uppercase text-slate-400 tracking-wider bg-slate-50 border-b border-slate-100">
                      <th className="p-4 pl-6">Invoice #</th>
                      <th className="p-4">Customer</th>
                      <th className="p-4">Rep / Date</th>
                      <th className="p-4 text-right">Net Value</th>
                      <th className="p-4 text-right">Realized</th>
                      <th className="p-4 text-right">Balance</th>
                      <th className="p-4 text-center">Status</th>
                      <th className="p-4 pr-6"></th> {/* Action header removed */}
                    </tr>
                  </thead>
                  <tbody className="text-xs font-bold divide-y divide-slate-100">
                    {completedSalesLedger.length === 0 ? (
                      <tr>
                        <td colSpan="8" className="p-12 text-center text-slate-400 font-medium">No recorded transactions match the active branch and date filter.</td>
                      </tr>
                    ) : (
                      completedSalesLedger.map(order => {
                        const net = order.financials?.netPayable || 0;
                        const paid = order.checkout?.totalAmountPaid || order.checkout?.advancePaid || 0;
                        const bal = order.financials?.balanceDue || 0;
                        const isPending = bal > 0;
                        const hasPrescription = order.prescription && (
                          order.prescription.sphRight || order.prescription.sphLeft || 
                          order.prescription.clSphRight || order.prescription.clSphLeft
                        );

                        return (
                          <tr key={order.id} className="hover:bg-slate-50/70 transition-colors">
                            <td className="p-4 pl-6 font-mono font-black text-blue-600">{order.invoiceNo}</td>
                            <td className="p-4">
                              <div className="text-slate-800">{order.customer?.name}</div>
                              <div className="text-[10px] text-slate-400 font-mono font-normal">{order.customer?.phone}</div>
                            </td>
                            <td className="p-4">
                              <div className="text-slate-700">{order.salesperson || 'System'}</div>
                              <div className="text-[10px] text-slate-400 font-mono font-normal">{new Date(order.timestamp).toLocaleDateString('en-GB')}</div>
                            </td>
                            <td className="p-4 text-right font-mono text-slate-800">₹{net.toLocaleString()}</td>
                            <td className="p-4 text-right font-mono text-emerald-600">₹{paid.toLocaleString()}</td>
                            <td className="p-4 text-right font-mono text-rose-600">₹{bal.toLocaleString()}</td>
                            <td className="p-4 text-center">
                              <span className={`px-2.5 py-1 rounded-full text-[10px] font-black uppercase tracking-wider ${isPending ? 'bg-amber-100 text-amber-800' : 'bg-emerald-100 text-emerald-800'}`}>
                                {isPending ? 'Pending' : 'Settled'}
                              </span>
                            </td>
                            <td className="p-4 pr-6">
                              {/* 2-ROW GRID FOR ACTIONS */}
                              <div className="grid grid-cols-5 gap-2 justify-end w-[180px] ml-auto">
                                

                                {isPending ? (
                                  <button 
                                    onClick={() => triggerCompletionFlow(order)} 
                                    title="Collect Remaining Balance"
                                    className="p-1.5 bg-emerald-50 hover:bg-emerald-600 hover:text-white text-emerald-700 rounded-xl transition flex items-center justify-center w-full h-full shadow-sm"
                                  >
                                    <CheckCircle2 size={15}/>
                                  </button>
                                ) : (
                                  <div className="p-1.5"></div> /* Empty space placeholder */
                                )}

                                <button 
                                  onClick={() => loadOrderForEditing(order)} 
                                  title="Edit Full Order Properties"
                                  className="p-1.5 bg-blue-50 hover:bg-blue-600 hover:text-white text-blue-700 rounded-xl transition flex items-center justify-center w-full h-full shadow-sm"
                                >
                                  <Edit3 size={15}/>
                                </button>
                                
                               {/* 📝 VIEW ORDER FORM */}
<button 
  onClick={() => handleViewPDF(order.invoiceNo, 'orderform')} 
  title="View Order Form PDF"
  className="p-1.5 bg-indigo-50 hover:bg-indigo-600 hover:text-white text-indigo-700 rounded-xl transition flex items-center justify-center w-full h-full shadow-sm"
>
  <ClipboardList size={15}/>
</button>

{/* 🧾 VIEW ADVANCE RECEIPT */}
<button 
  onClick={() => handleViewPDF(order.invoiceNo, 'advance-receipt')} 
  title="View Advance Receipt PDF"
  className="p-1.5 bg-amber-50 hover:bg-amber-600 hover:text-white text-amber-700 rounded-xl transition flex items-center justify-center w-full h-full shadow-sm"
>
  <Receipt size={15}/>
</button>

{/* 🖨️ VIEW FINAL RECEIPT (Only if Settled) */}
{!isPending ? (
  <button 
    onClick={() => handleViewPDF(order.invoiceNo, 'receipt')} 
    title="View Final Bill PDF"
    className="p-1.5 bg-slate-100 hover:bg-slate-700 hover:text-white text-slate-700 rounded-xl transition flex items-center justify-center w-full h-full shadow-sm"
  >
    <Printer size={15}/>
  </button>
) : (
  <div className="p-1.5"></div>
)}

{/* 👁️ VIEW PRESCRIPTION */}
<button 
  onClick={() => handleViewPDF(order.invoiceNo, 'prescription')} 
  title="View PDF Prescription"
  className="p-1.5 bg-purple-50 hover:bg-purple-600 hover:text-white text-purple-700 rounded-xl transition flex items-center justify-center w-full h-full shadow-sm"
>
  <FileText size={15}/>
</button>

                                {/* 💬 SMS BUTTON (NEWLY ADDED) */}
                                <button 
                                  onClick={() => { setContactMethod('sms'); setContactOrder(order); setShowContactModal(true); }} 
                                  title="Send SMS Notification"
                                  className="p-1.5 bg-blue-50 hover:bg-blue-600 hover:text-white text-blue-600 rounded-xl transition flex items-center justify-center w-full h-full shadow-sm"
                                >
                                  <MessageSquare size={15}/>
                                </button>

                                {/* 💬 WHATSAPP BUTTON */}
                                <button 
                                  onClick={() => { setContactMethod('whatsapp'); setContactOrder(order); setShowContactModal(true); }} 
                                  title="Send WhatsApp Notification"
                                  className="p-1.5 bg-green-50 hover:bg-green-600 hover:text-white text-green-600 rounded-xl transition flex items-center justify-center w-full h-full shadow-sm"
                                >
                                  <MessageCircle size={15}/>
                                </button>

                                <button 
                                  onClick={() => handleDeleteOrder(order.id)} 
                                  title="Delete Order Log"
                                  className="p-1.5 bg-rose-50 hover:bg-rose-600 hover:text-white text-rose-600 rounded-xl transition flex items-center justify-center w-full h-full shadow-sm"
                                >
                                  <Trash2 size={15}/>
                                </button>
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>
              </div>
            </div>

          </div>
        )}

      </div>
    </div>
  );
}